// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.5.0
// @Generated: 2022-10-26T01:10:52.933Z
//
// This file is generated on each build. Do not edit this file!
import { pluginFactoryNoConfig } from '../utils/plugins'; // Icon helper component

import { BIcon } from './icon'; // Icon stacking component

import { BIconstack } from './iconstack';
import { // BootstrapVue custom icons
BIconBlank, // Bootstrap icons
BIconAlarm, BIconAlarmFill, BIconAlignBottom, BIconAlignCenter, BIconAlignEnd, BIconAlignMiddle, BIconAlignStart, BIconAlignTop, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownCircle, BIconArrowDownCircleFill, BIconArrowDownLeft, BIconArrowDownLeftCircle, BIconArrowDownLeftCircleFill, BIconArrowDownLeftSquare, BIconArrowDownLeftSquareFill, BIconArrowDownRight, BIconArrowDownRightCircle, BIconArrowDownRightCircleFill, BIconArrowDownRightSquare, BIconArrowDownRightSquareFill, BIconArrowDownShort, BIconArrowDownSquare, BIconArrowDownSquareFill, BIconArrowDownUp, BIconArrowLeft, BIconArrowLeftCircle, BIconArrowLeftCircleFill, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowLeftSquare, BIconArrowLeftSquareFill, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightCircle, BIconArrowRightCircleFill, BIconArrowRightShort, BIconArrowRightSquare, BIconArrowRightSquareFill, BIconArrowUp, BIconArrowUpCircle, BIconArrowUpCircleFill, BIconArrowUpLeft, BIconArrowUpLeftCircle, BIconArrowUpLeftCircleFill, BIconArrowUpLeftSquare, BIconArrowUpLeftSquareFill, BIconArrowUpRight, BIconArrowUpRightCircle, BIconArrowUpRightCircleFill, BIconArrowUpRightSquare, BIconArrowUpRightSquareFill, BIconArrowUpShort, BIconArrowUpSquare, BIconArrowUpSquareFill, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAsterisk, BIconAt, BIconAward, BIconAwardFill, BIconBack, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBadge3d, BIconBadge3dFill, BIconBadge4k, BIconBadge4kFill, BIconBadge8k, BIconBadge8kFill, BIconBadgeAd, BIconBadgeAdFill, BIconBadgeAr, BIconBadgeArFill, BIconBadgeCc, BIconBadgeCcFill, BIconBadgeHd, BIconBadgeHdFill, BIconBadgeTm, BIconBadgeTmFill, BIconBadgeVo, BIconBadgeVoFill, BIconBadgeVr, BIconBadgeVrFill, BIconBadgeWc, BIconBadgeWcFill, BIconBag, BIconBagCheck, BIconBagCheckFill, BIconBagDash, BIconBagDashFill, BIconBagFill, BIconBagPlus, BIconBagPlusFill, BIconBagX, BIconBagXFill, BIconBank, BIconBank2, BIconBarChart, BIconBarChartFill, BIconBarChartLine, BIconBarChartLineFill, BIconBarChartSteps, BIconBasket, BIconBasket2, BIconBasket2Fill, BIconBasket3, BIconBasket3Fill, BIconBasketFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBellSlash, BIconBellSlashFill, BIconBezier, BIconBezier2, BIconBicycle, BIconBinoculars, BIconBinocularsFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookFill, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkCheckFill, BIconBookmarkDash, BIconBookmarkDashFill, BIconBookmarkFill, BIconBookmarkHeart, BIconBookmarkHeartFill, BIconBookmarkPlus, BIconBookmarkPlusFill, BIconBookmarkStar, BIconBookmarkStarFill, BIconBookmarkX, BIconBookmarkXFill, BIconBookmarks, BIconBookmarksFill, BIconBookshelf, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBorder, BIconBorderAll, BIconBorderBottom, BIconBorderCenter, BIconBorderInner, BIconBorderLeft, BIconBorderMiddle, BIconBorderOuter, BIconBorderRight, BIconBorderStyle, BIconBorderTop, BIconBorderWidth, BIconBoundingBox, BIconBoundingBoxCircles, BIconBox, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBoxSeam, BIconBraces, BIconBricks, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBroadcast, BIconBroadcastPin, BIconBrush, BIconBrushFill, BIconBucket, BIconBucketFill, BIconBug, BIconBugFill, BIconBuilding, BIconBullseye, BIconCalculator, BIconCalculatorFill, BIconCalendar, BIconCalendar2, BIconCalendar2Check, BIconCalendar2CheckFill, BIconCalendar2Date, BIconCalendar2DateFill, BIconCalendar2Day, BIconCalendar2DayFill, BIconCalendar2Event, BIconCalendar2EventFill, BIconCalendar2Fill, BIconCalendar2Minus, BIconCalendar2MinusFill, BIconCalendar2Month, BIconCalendar2MonthFill, BIconCalendar2Plus, BIconCalendar2PlusFill, BIconCalendar2Range, BIconCalendar2RangeFill, BIconCalendar2Week, BIconCalendar2WeekFill, BIconCalendar2X, BIconCalendar2XFill, BIconCalendar3, BIconCalendar3Event, BIconCalendar3EventFill, BIconCalendar3Fill, BIconCalendar3Range, BIconCalendar3RangeFill, BIconCalendar3Week, BIconCalendar3WeekFill, BIconCalendar4, BIconCalendar4Event, BIconCalendar4Range, BIconCalendar4Week, BIconCalendarCheck, BIconCalendarCheckFill, BIconCalendarDate, BIconCalendarDateFill, BIconCalendarDay, BIconCalendarDayFill, BIconCalendarEvent, BIconCalendarEventFill, BIconCalendarFill, BIconCalendarMinus, BIconCalendarMinusFill, BIconCalendarMonth, BIconCalendarMonthFill, BIconCalendarPlus, BIconCalendarPlusFill, BIconCalendarRange, BIconCalendarRangeFill, BIconCalendarWeek, BIconCalendarWeekFill, BIconCalendarX, BIconCalendarXFill, BIconCamera, BIconCamera2, BIconCameraFill, BIconCameraReels, BIconCameraReelsFill, BIconCameraVideo, BIconCameraVideoFill, BIconCameraVideoOff, BIconCameraVideoOffFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretDownSquare, BIconCaretDownSquareFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretLeftSquare, BIconCaretLeftSquareFill, BIconCaretRight, BIconCaretRightFill, BIconCaretRightSquare, BIconCaretRightSquareFill, BIconCaretUp, BIconCaretUpFill, BIconCaretUpSquare, BIconCaretUpSquareFill, BIconCart, BIconCart2, BIconCart3, BIconCart4, BIconCartCheck, BIconCartCheckFill, BIconCartDash, BIconCartDashFill, BIconCartFill, BIconCartPlus, BIconCartPlusFill, BIconCartX, BIconCartXFill, BIconCash, BIconCashCoin, BIconCashStack, BIconCast, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatLeft, BIconChatLeftDots, BIconChatLeftDotsFill, BIconChatLeftFill, BIconChatLeftQuote, BIconChatLeftQuoteFill, BIconChatLeftText, BIconChatLeftTextFill, BIconChatQuote, BIconChatQuoteFill, BIconChatRight, BIconChatRightDots, BIconChatRightDotsFill, BIconChatRightFill, BIconChatRightQuote, BIconChatRightQuoteFill, BIconChatRightText, BIconChatRightTextFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconChatSquareText, BIconChatSquareTextFill, BIconChatText, BIconChatTextFill, BIconCheck, BIconCheck2, BIconCheck2All, BIconCheck2Circle, BIconCheck2Square, BIconCheckAll, BIconCheckCircle, BIconCheckCircleFill, BIconCheckLg, BIconCheckSquare, BIconCheckSquareFill, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardCheck, BIconClipboardData, BIconClipboardMinus, BIconClipboardPlus, BIconClipboardX, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudArrowDown, BIconCloudArrowDownFill, BIconCloudArrowUp, BIconCloudArrowUpFill, BIconCloudCheck, BIconCloudCheckFill, BIconCloudDownload, BIconCloudDownloadFill, BIconCloudDrizzle, BIconCloudDrizzleFill, BIconCloudFill, BIconCloudFog, BIconCloudFog2, BIconCloudFog2Fill, BIconCloudFogFill, BIconCloudHail, BIconCloudHailFill, BIconCloudHaze, BIconCloudHaze1, BIconCloudHaze2Fill, BIconCloudHazeFill, BIconCloudLightning, BIconCloudLightningFill, BIconCloudLightningRain, BIconCloudLightningRainFill, BIconCloudMinus, BIconCloudMinusFill, BIconCloudMoon, BIconCloudMoonFill, BIconCloudPlus, BIconCloudPlusFill, BIconCloudRain, BIconCloudRainFill, BIconCloudRainHeavy, BIconCloudRainHeavyFill, BIconCloudSlash, BIconCloudSlashFill, BIconCloudSleet, BIconCloudSleetFill, BIconCloudSnow, BIconCloudSnowFill, BIconCloudSun, BIconCloudSunFill, BIconCloudUpload, BIconCloudUploadFill, BIconClouds, BIconCloudsFill, BIconCloudy, BIconCloudyFill, BIconCode, BIconCodeSlash, BIconCodeSquare, BIconCoin, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCompassFill, BIconCone, BIconConeStriped, BIconController, BIconCpu, BIconCpuFill, BIconCreditCard, BIconCreditCard2Back, BIconCreditCard2BackFill, BIconCreditCard2Front, BIconCreditCard2FrontFill, BIconCreditCardFill, BIconCrop, BIconCup, BIconCupFill, BIconCupStraw, BIconCurrencyBitcoin, BIconCurrencyDollar, BIconCurrencyEuro, BIconCurrencyExchange, BIconCurrencyPound, BIconCurrencyYen, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleDotted, BIconDashCircleFill, BIconDashLg, BIconDashSquare, BIconDashSquareDotted, BIconDashSquareFill, BIconDiagram2, BIconDiagram2Fill, BIconDiagram3, BIconDiagram3Fill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDice1, BIconDice1Fill, BIconDice2, BIconDice2Fill, BIconDice3, BIconDice3Fill, BIconDice4, BIconDice4Fill, BIconDice5, BIconDice5Fill, BIconDice6, BIconDice6Fill, BIconDisc, BIconDiscFill, BIconDiscord, BIconDisplay, BIconDisplayFill, BIconDistributeHorizontal, BIconDistributeVertical, BIconDoorClosed, BIconDoorClosedFill, BIconDoorOpen, BIconDoorOpenFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEarbuds, BIconEasel, BIconEaselFill, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEmojiAngry, BIconEmojiAngryFill, BIconEmojiDizzy, BIconEmojiDizzyFill, BIconEmojiExpressionless, BIconEmojiExpressionlessFill, BIconEmojiFrown, BIconEmojiFrownFill, BIconEmojiHeartEyes, BIconEmojiHeartEyesFill, BIconEmojiLaughing, BIconEmojiLaughingFill, BIconEmojiNeutral, BIconEmojiNeutralFill, BIconEmojiSmile, BIconEmojiSmileFill, BIconEmojiSmileUpsideDown, BIconEmojiSmileUpsideDownFill, BIconEmojiSunglasses, BIconEmojiSunglassesFill, BIconEmojiWink, BIconEmojiWinkFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconEraser, BIconEraserFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationLg, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconEyedropper, BIconEyeglasses, BIconFacebook, BIconFile, BIconFileArrowDown, BIconFileArrowDownFill, BIconFileArrowUp, BIconFileArrowUpFill, BIconFileBarGraph, BIconFileBarGraphFill, BIconFileBinary, BIconFileBinaryFill, BIconFileBreak, BIconFileBreakFill, BIconFileCheck, BIconFileCheckFill, BIconFileCode, BIconFileCodeFill, BIconFileDiff, BIconFileDiffFill, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowDownFill, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowUpFill, BIconFileEarmarkBarGraph, BIconFileEarmarkBarGraphFill, BIconFileEarmarkBinary, BIconFileEarmarkBinaryFill, BIconFileEarmarkBreak, BIconFileEarmarkBreakFill, BIconFileEarmarkCheck, BIconFileEarmarkCheckFill, BIconFileEarmarkCode, BIconFileEarmarkCodeFill, BIconFileEarmarkDiff, BIconFileEarmarkDiffFill, BIconFileEarmarkEasel, BIconFileEarmarkEaselFill, BIconFileEarmarkExcel, BIconFileEarmarkExcelFill, BIconFileEarmarkFill, BIconFileEarmarkFont, BIconFileEarmarkFontFill, BIconFileEarmarkImage, BIconFileEarmarkImageFill, BIconFileEarmarkLock, BIconFileEarmarkLock2, BIconFileEarmarkLock2Fill, BIconFileEarmarkLockFill, BIconFileEarmarkMedical, BIconFileEarmarkMedicalFill, BIconFileEarmarkMinus, BIconFileEarmarkMinusFill, BIconFileEarmarkMusic, BIconFileEarmarkMusicFill, BIconFileEarmarkPdf, BIconFileEarmarkPdfFill, BIconFileEarmarkPerson, BIconFileEarmarkPersonFill, BIconFileEarmarkPlay, BIconFileEarmarkPlayFill, BIconFileEarmarkPlus, BIconFileEarmarkPlusFill, BIconFileEarmarkPost, BIconFileEarmarkPostFill, BIconFileEarmarkPpt, BIconFileEarmarkPptFill, BIconFileEarmarkRichtext, BIconFileEarmarkRichtextFill, BIconFileEarmarkRuled, BIconFileEarmarkRuledFill, BIconFileEarmarkSlides, BIconFileEarmarkSlidesFill, BIconFileEarmarkSpreadsheet, BIconFileEarmarkSpreadsheetFill, BIconFileEarmarkText, BIconFileEarmarkTextFill, BIconFileEarmarkWord, BIconFileEarmarkWordFill, BIconFileEarmarkX, BIconFileEarmarkXFill, BIconFileEarmarkZip, BIconFileEarmarkZipFill, BIconFileEasel, BIconFileEaselFill, BIconFileExcel, BIconFileExcelFill, BIconFileFill, BIconFileFont, BIconFileFontFill, BIconFileImage, BIconFileImageFill, BIconFileLock, BIconFileLock2, BIconFileLock2Fill, BIconFileLockFill, BIconFileMedical, BIconFileMedicalFill, BIconFileMinus, BIconFileMinusFill, BIconFileMusic, BIconFileMusicFill, BIconFilePdf, BIconFilePdfFill, BIconFilePerson, BIconFilePersonFill, BIconFilePlay, BIconFilePlayFill, BIconFilePlus, BIconFilePlusFill, BIconFilePost, BIconFilePostFill, BIconFilePpt, BIconFilePptFill, BIconFileRichtext, BIconFileRichtextFill, BIconFileRuled, BIconFileRuledFill, BIconFileSlides, BIconFileSlidesFill, BIconFileSpreadsheet, BIconFileSpreadsheetFill, BIconFileText, BIconFileTextFill, BIconFileWord, BIconFileWordFill, BIconFileX, BIconFileXFill, BIconFileZip, BIconFileZipFill, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterCircle, BIconFilterCircleFill, BIconFilterLeft, BIconFilterRight, BIconFilterSquare, BIconFilterSquareFill, BIconFlag, BIconFlagFill, BIconFlower1, BIconFlower2, BIconFlower3, BIconFolder, BIconFolder2, BIconFolder2Open, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFolderX, BIconFonts, BIconForward, BIconForwardFill, BIconFront, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGenderAmbiguous, BIconGenderFemale, BIconGenderMale, BIconGenderTrans, BIconGeo, BIconGeoAlt, BIconGeoAltFill, BIconGeoFill, BIconGift, BIconGiftFill, BIconGithub, BIconGlobe, BIconGlobe2, BIconGoogle, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconGripHorizontal, BIconGripVertical, BIconHammer, BIconHandIndex, BIconHandIndexFill, BIconHandIndexThumb, BIconHandIndexThumbFill, BIconHandThumbsDown, BIconHandThumbsDownFill, BIconHandThumbsUp, BIconHandThumbsUpFill, BIconHandbag, BIconHandbagFill, BIconHash, BIconHdd, BIconHddFill, BIconHddNetwork, BIconHddNetworkFill, BIconHddRack, BIconHddRackFill, BIconHddStack, BIconHddStackFill, BIconHeadphones, BIconHeadset, BIconHeadsetVr, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHeptagon, BIconHeptagonFill, BIconHeptagonHalf, BIconHexagon, BIconHexagonFill, BIconHexagonHalf, BIconHourglass, BIconHourglassBottom, BIconHourglassSplit, BIconHourglassTop, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconHurricane, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoLg, BIconInfoSquare, BIconInfoSquareFill, BIconInputCursor, BIconInputCursorText, BIconInstagram, BIconIntersect, BIconJournal, BIconJournalAlbum, BIconJournalArrowDown, BIconJournalArrowUp, BIconJournalBookmark, BIconJournalBookmarkFill, BIconJournalCheck, BIconJournalCode, BIconJournalMedical, BIconJournalMinus, BIconJournalPlus, BIconJournalRichtext, BIconJournalText, BIconJournalX, BIconJournals, BIconJoystick, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconKey, BIconKeyFill, BIconKeyboard, BIconKeyboardFill, BIconLadder, BIconLamp, BIconLampFill, BIconLaptop, BIconLaptopFill, BIconLayerBackward, BIconLayerForward, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightbulb, BIconLightbulbFill, BIconLightbulbOff, BIconLightbulbOffFill, BIconLightning, BIconLightningCharge, BIconLightningChargeFill, BIconLightningFill, BIconLink, BIconLink45deg, BIconLinkedin, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListStars, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMailbox, BIconMailbox2, BIconMap, BIconMapFill, BIconMarkdown, BIconMarkdownFill, BIconMask, BIconMastodon, BIconMegaphone, BIconMegaphoneFill, BIconMenuApp, BIconMenuAppFill, BIconMenuButton, BIconMenuButtonFill, BIconMenuButtonWide, BIconMenuButtonWideFill, BIconMenuDown, BIconMenuUp, BIconMessenger, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMinecart, BIconMinecartLoaded, BIconMoisture, BIconMoon, BIconMoonFill, BIconMoonStars, BIconMoonStarsFill, BIconMouse, BIconMouse2, BIconMouse2Fill, BIconMouse3, BIconMouse3Fill, BIconMouseFill, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconNodeMinus, BIconNodeMinusFill, BIconNodePlus, BIconNodePlusFill, BIconNut, BIconNutFill, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaintBucket, BIconPalette, BIconPalette2, BIconPaletteFill, BIconPaperclip, BIconParagraph, BIconPatchCheck, BIconPatchCheckFill, BIconPatchExclamation, BIconPatchExclamationFill, BIconPatchMinus, BIconPatchMinusFill, BIconPatchPlus, BIconPatchPlusFill, BIconPatchQuestion, BIconPatchQuestionFill, BIconPause, BIconPauseBtn, BIconPauseBtnFill, BIconPauseCircle, BIconPauseCircleFill, BIconPauseFill, BIconPeace, BIconPeaceFill, BIconPen, BIconPenFill, BIconPencil, BIconPencilFill, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleFill, BIconPercent, BIconPerson, BIconPersonBadge, BIconPersonBadgeFill, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonCircle, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPersonX, BIconPersonXFill, BIconPhone, BIconPhoneFill, BIconPhoneLandscape, BIconPhoneLandscapeFill, BIconPhoneVibrate, BIconPhoneVibrateFill, BIconPieChart, BIconPieChartFill, BIconPiggyBank, BIconPiggyBankFill, BIconPin, BIconPinAngle, BIconPinAngleFill, BIconPinFill, BIconPinMap, BIconPinMapFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayBtn, BIconPlayBtnFill, BIconPlayCircle, BIconPlayCircleFill, BIconPlayFill, BIconPlug, BIconPlugFill, BIconPlus, BIconPlusCircle, BIconPlusCircleDotted, BIconPlusCircleFill, BIconPlusLg, BIconPlusSquare, BIconPlusSquareDotted, BIconPlusSquareFill, BIconPower, BIconPrinter, BIconPrinterFill, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionLg, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconRainbow, BIconReceipt, BIconReceiptCutoff, BIconReception0, BIconReception1, BIconReception2, BIconReception3, BIconReception4, BIconRecord, BIconRecord2, BIconRecord2Fill, BIconRecordBtn, BIconRecordBtnFill, BIconRecordCircle, BIconRecordCircleFill, BIconRecordFill, BIconRecycle, BIconReddit, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconRss, BIconRssFill, BIconRulers, BIconSafe, BIconSafe2, BIconSafe2Fill, BIconSafeFill, BIconSave, BIconSave2, BIconSave2Fill, BIconSaveFill, BIconScissors, BIconScrewdriver, BIconSdCard, BIconSdCardFill, BIconSearch, BIconSegmentedNav, BIconServer, BIconShare, BIconShareFill, BIconShield, BIconShieldCheck, BIconShieldExclamation, BIconShieldFill, BIconShieldFillCheck, BIconShieldFillExclamation, BIconShieldFillMinus, BIconShieldFillPlus, BIconShieldFillX, BIconShieldLock, BIconShieldLockFill, BIconShieldMinus, BIconShieldPlus, BIconShieldShaded, BIconShieldSlash, BIconShieldSlashFill, BIconShieldX, BIconShift, BIconShiftFill, BIconShop, BIconShopWindow, BIconShuffle, BIconSignpost, BIconSignpost2, BIconSignpost2Fill, BIconSignpostFill, BIconSignpostSplit, BIconSignpostSplitFill, BIconSim, BIconSimFill, BIconSkipBackward, BIconSkipBackwardBtn, BIconSkipBackwardBtnFill, BIconSkipBackwardCircle, BIconSkipBackwardCircleFill, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndBtn, BIconSkipEndBtnFill, BIconSkipEndCircle, BIconSkipEndCircleFill, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardBtn, BIconSkipForwardBtnFill, BIconSkipForwardCircle, BIconSkipForwardCircleFill, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartBtn, BIconSkipStartBtnFill, BIconSkipStartCircle, BIconSkipStartCircleFill, BIconSkipStartFill, BIconSkype, BIconSlack, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashLg, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSmartwatch, BIconSnow, BIconSnow2, BIconSnow3, BIconSortAlphaDown, BIconSortAlphaDownAlt, BIconSortAlphaUp, BIconSortAlphaUpAlt, BIconSortDown, BIconSortDownAlt, BIconSortNumericDown, BIconSortNumericDownAlt, BIconSortNumericUp, BIconSortNumericUpAlt, BIconSortUp, BIconSortUpAlt, BIconSoundwave, BIconSpeaker, BIconSpeakerFill, BIconSpeedometer, BIconSpeedometer2, BIconSpellcheck, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStack, BIconStar, BIconStarFill, BIconStarHalf, BIconStars, BIconStickies, BIconStickiesFill, BIconSticky, BIconStickyFill, BIconStop, BIconStopBtn, BIconStopBtnFill, BIconStopCircle, BIconStopCircleFill, BIconStopFill, BIconStoplights, BIconStoplightsFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSuitClub, BIconSuitClubFill, BIconSuitDiamond, BIconSuitDiamondFill, BIconSuitHeart, BIconSuitHeartFill, BIconSuitSpade, BIconSuitSpadeFill, BIconSun, BIconSunFill, BIconSunglasses, BIconSunrise, BIconSunriseFill, BIconSunset, BIconSunsetFill, BIconSymmetryHorizontal, BIconSymmetryVertical, BIconTable, BIconTablet, BIconTabletFill, BIconTabletLandscape, BIconTabletLandscapeFill, BIconTag, BIconTagFill, BIconTags, BIconTagsFill, BIconTelegram, BIconTelephone, BIconTelephoneFill, BIconTelephoneForward, BIconTelephoneForwardFill, BIconTelephoneInbound, BIconTelephoneInboundFill, BIconTelephoneMinus, BIconTelephoneMinusFill, BIconTelephoneOutbound, BIconTelephoneOutboundFill, BIconTelephonePlus, BIconTelephonePlusFill, BIconTelephoneX, BIconTelephoneXFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextParagraph, BIconTextRight, BIconTextarea, BIconTextareaResize, BIconTextareaT, BIconThermometer, BIconThermometerHalf, BIconThermometerHigh, BIconThermometerLow, BIconThermometerSnow, BIconThermometerSun, BIconThreeDots, BIconThreeDotsVertical, BIconToggle2Off, BIconToggle2On, BIconToggleOff, BIconToggleOn, BIconToggles, BIconToggles2, BIconTools, BIconTornado, BIconTranslate, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTree, BIconTreeFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTrophyFill, BIconTropicalStorm, BIconTruck, BIconTruckFlatbed, BIconTsunami, BIconTv, BIconTvFill, BIconTwitch, BIconTwitter, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUiChecks, BIconUiChecksGrid, BIconUiRadios, BIconUiRadiosGrid, BIconUmbrella, BIconUmbrellaFill, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpc, BIconUpcScan, BIconUpload, BIconVectorPen, BIconViewList, BIconViewStacked, BIconVinyl, BIconVinylFill, BIconVoicemail, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeOff, BIconVolumeOffFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWallet2, BIconWalletFill, BIconWatch, BIconWater, BIconWhatsapp, BIconWifi, BIconWifi1, BIconWifi2, BIconWifiOff, BIconWind, BIconWindow, BIconWindowDock, BIconWindowSidebar, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXLg, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill, BIconYoutube, BIconZoomIn, BIconZoomOut } from './icons'; // Icon component names for used in the docs

export var iconNames = [// BootstrapVue custom icon component names
'BIconBlank', // Bootstrap icon component names
'BIconAlarm', 'BIconAlarmFill', 'BIconAlignBottom', 'BIconAlignCenter', 'BIconAlignEnd', 'BIconAlignMiddle', 'BIconAlignStart', 'BIconAlignTop', 'BIconAlt', 'BIconApp', 'BIconAppIndicator', 'BIconArchive', 'BIconArchiveFill', 'BIconArrow90degDown', 'BIconArrow90degLeft', 'BIconArrow90degRight', 'BIconArrow90degUp', 'BIconArrowBarDown', 'BIconArrowBarLeft', 'BIconArrowBarRight', 'BIconArrowBarUp', 'BIconArrowClockwise', 'BIconArrowCounterclockwise', 'BIconArrowDown', 'BIconArrowDownCircle', 'BIconArrowDownCircleFill', 'BIconArrowDownLeft', 'BIconArrowDownLeftCircle', 'BIconArrowDownLeftCircleFill', 'BIconArrowDownLeftSquare', 'BIconArrowDownLeftSquareFill', 'BIconArrowDownRight', 'BIconArrowDownRightCircle', 'BIconArrowDownRightCircleFill', 'BIconArrowDownRightSquare', 'BIconArrowDownRightSquareFill', 'BIconArrowDownShort', 'BIconArrowDownSquare', 'BIconArrowDownSquareFill', 'BIconArrowDownUp', 'BIconArrowLeft', 'BIconArrowLeftCircle', 'BIconArrowLeftCircleFill', 'BIconArrowLeftRight', 'BIconArrowLeftShort', 'BIconArrowLeftSquare', 'BIconArrowLeftSquareFill', 'BIconArrowRepeat', 'BIconArrowReturnLeft', 'BIconArrowReturnRight', 'BIconArrowRight', 'BIconArrowRightCircle', 'BIconArrowRightCircleFill', 'BIconArrowRightShort', 'BIconArrowRightSquare', 'BIconArrowRightSquareFill', 'BIconArrowUp', 'BIconArrowUpCircle', 'BIconArrowUpCircleFill', 'BIconArrowUpLeft', 'BIconArrowUpLeftCircle', 'BIconArrowUpLeftCircleFill', 'BIconArrowUpLeftSquare', 'BIconArrowUpLeftSquareFill', 'BIconArrowUpRight', 'BIconArrowUpRightCircle', 'BIconArrowUpRightCircleFill', 'BIconArrowUpRightSquare', 'BIconArrowUpRightSquareFill', 'BIconArrowUpShort', 'BIconArrowUpSquare', 'BIconArrowUpSquareFill', 'BIconArrowsAngleContract', 'BIconArrowsAngleExpand', 'BIconArrowsCollapse', 'BIconArrowsExpand', 'BIconArrowsFullscreen', 'BIconArrowsMove', 'BIconAspectRatio', 'BIconAspectRatioFill', 'BIconAsterisk', 'BIconAt', 'BIconAward', 'BIconAwardFill', 'BIconBack', 'BIconBackspace', 'BIconBackspaceFill', 'BIconBackspaceReverse', 'BIconBackspaceReverseFill', 'BIconBadge3d', 'BIconBadge3dFill', 'BIconBadge4k', 'BIconBadge4kFill', 'BIconBadge8k', 'BIconBadge8kFill', 'BIconBadgeAd', 'BIconBadgeAdFill', 'BIconBadgeAr', 'BIconBadgeArFill', 'BIconBadgeCc', 'BIconBadgeCcFill', 'BIconBadgeHd', 'BIconBadgeHdFill', 'BIconBadgeTm', 'BIconBadgeTmFill', 'BIconBadgeVo', 'BIconBadgeVoFill', 'BIconBadgeVr', 'BIconBadgeVrFill', 'BIconBadgeWc', 'BIconBadgeWcFill', 'BIconBag', 'BIconBagCheck', 'BIconBagCheckFill', 'BIconBagDash', 'BIconBagDashFill', 'BIconBagFill', 'BIconBagPlus', 'BIconBagPlusFill', 'BIconBagX', 'BIconBagXFill', 'BIconBank', 'BIconBank2', 'BIconBarChart', 'BIconBarChartFill', 'BIconBarChartLine', 'BIconBarChartLineFill', 'BIconBarChartSteps', 'BIconBasket', 'BIconBasket2', 'BIconBasket2Fill', 'BIconBasket3', 'BIconBasket3Fill', 'BIconBasketFill', 'BIconBattery', 'BIconBatteryCharging', 'BIconBatteryFull', 'BIconBatteryHalf', 'BIconBell', 'BIconBellFill', 'BIconBellSlash', 'BIconBellSlashFill', 'BIconBezier', 'BIconBezier2', 'BIconBicycle', 'BIconBinoculars', 'BIconBinocularsFill', 'BIconBlockquoteLeft', 'BIconBlockquoteRight', 'BIconBook', 'BIconBookFill', 'BIconBookHalf', 'BIconBookmark', 'BIconBookmarkCheck', 'BIconBookmarkCheckFill', 'BIconBookmarkDash', 'BIconBookmarkDashFill', 'BIconBookmarkFill', 'BIconBookmarkHeart', 'BIconBookmarkHeartFill', 'BIconBookmarkPlus', 'BIconBookmarkPlusFill', 'BIconBookmarkStar', 'BIconBookmarkStarFill', 'BIconBookmarkX', 'BIconBookmarkXFill', 'BIconBookmarks', 'BIconBookmarksFill', 'BIconBookshelf', 'BIconBootstrap', 'BIconBootstrapFill', 'BIconBootstrapReboot', 'BIconBorder', 'BIconBorderAll', 'BIconBorderBottom', 'BIconBorderCenter', 'BIconBorderInner', 'BIconBorderLeft', 'BIconBorderMiddle', 'BIconBorderOuter', 'BIconBorderRight', 'BIconBorderStyle', 'BIconBorderTop', 'BIconBorderWidth', 'BIconBoundingBox', 'BIconBoundingBoxCircles', 'BIconBox', 'BIconBoxArrowDown', 'BIconBoxArrowDownLeft', 'BIconBoxArrowDownRight', 'BIconBoxArrowInDown', 'BIconBoxArrowInDownLeft', 'BIconBoxArrowInDownRight', 'BIconBoxArrowInLeft', 'BIconBoxArrowInRight', 'BIconBoxArrowInUp', 'BIconBoxArrowInUpLeft', 'BIconBoxArrowInUpRight', 'BIconBoxArrowLeft', 'BIconBoxArrowRight', 'BIconBoxArrowUp', 'BIconBoxArrowUpLeft', 'BIconBoxArrowUpRight', 'BIconBoxSeam', 'BIconBraces', 'BIconBricks', 'BIconBriefcase', 'BIconBriefcaseFill', 'BIconBrightnessAltHigh', 'BIconBrightnessAltHighFill', 'BIconBrightnessAltLow', 'BIconBrightnessAltLowFill', 'BIconBrightnessHigh', 'BIconBrightnessHighFill', 'BIconBrightnessLow', 'BIconBrightnessLowFill', 'BIconBroadcast', 'BIconBroadcastPin', 'BIconBrush', 'BIconBrushFill', 'BIconBucket', 'BIconBucketFill', 'BIconBug', 'BIconBugFill', 'BIconBuilding', 'BIconBullseye', 'BIconCalculator', 'BIconCalculatorFill', 'BIconCalendar', 'BIconCalendar2', 'BIconCalendar2Check', 'BIconCalendar2CheckFill', 'BIconCalendar2Date', 'BIconCalendar2DateFill', 'BIconCalendar2Day', 'BIconCalendar2DayFill', 'BIconCalendar2Event', 'BIconCalendar2EventFill', 'BIconCalendar2Fill', 'BIconCalendar2Minus', 'BIconCalendar2MinusFill', 'BIconCalendar2Month', 'BIconCalendar2MonthFill', 'BIconCalendar2Plus', 'BIconCalendar2PlusFill', 'BIconCalendar2Range', 'BIconCalendar2RangeFill', 'BIconCalendar2Week', 'BIconCalendar2WeekFill', 'BIconCalendar2X', 'BIconCalendar2XFill', 'BIconCalendar3', 'BIconCalendar3Event', 'BIconCalendar3EventFill', 'BIconCalendar3Fill', 'BIconCalendar3Range', 'BIconCalendar3RangeFill', 'BIconCalendar3Week', 'BIconCalendar3WeekFill', 'BIconCalendar4', 'BIconCalendar4Event', 'BIconCalendar4Range', 'BIconCalendar4Week', 'BIconCalendarCheck', 'BIconCalendarCheckFill', 'BIconCalendarDate', 'BIconCalendarDateFill', 'BIconCalendarDay', 'BIconCalendarDayFill', 'BIconCalendarEvent', 'BIconCalendarEventFill', 'BIconCalendarFill', 'BIconCalendarMinus', 'BIconCalendarMinusFill', 'BIconCalendarMonth', 'BIconCalendarMonthFill', 'BIconCalendarPlus', 'BIconCalendarPlusFill', 'BIconCalendarRange', 'BIconCalendarRangeFill', 'BIconCalendarWeek', 'BIconCalendarWeekFill', 'BIconCalendarX', 'BIconCalendarXFill', 'BIconCamera', 'BIconCamera2', 'BIconCameraFill', 'BIconCameraReels', 'BIconCameraReelsFill', 'BIconCameraVideo', 'BIconCameraVideoFill', 'BIconCameraVideoOff', 'BIconCameraVideoOffFill', 'BIconCapslock', 'BIconCapslockFill', 'BIconCardChecklist', 'BIconCardHeading', 'BIconCardImage', 'BIconCardList', 'BIconCardText', 'BIconCaretDown', 'BIconCaretDownFill', 'BIconCaretDownSquare', 'BIconCaretDownSquareFill', 'BIconCaretLeft', 'BIconCaretLeftFill', 'BIconCaretLeftSquare', 'BIconCaretLeftSquareFill', 'BIconCaretRight', 'BIconCaretRightFill', 'BIconCaretRightSquare', 'BIconCaretRightSquareFill', 'BIconCaretUp', 'BIconCaretUpFill', 'BIconCaretUpSquare', 'BIconCaretUpSquareFill', 'BIconCart', 'BIconCart2', 'BIconCart3', 'BIconCart4', 'BIconCartCheck', 'BIconCartCheckFill', 'BIconCartDash', 'BIconCartDashFill', 'BIconCartFill', 'BIconCartPlus', 'BIconCartPlusFill', 'BIconCartX', 'BIconCartXFill', 'BIconCash', 'BIconCashCoin', 'BIconCashStack', 'BIconCast', 'BIconChat', 'BIconChatDots', 'BIconChatDotsFill', 'BIconChatFill', 'BIconChatLeft', 'BIconChatLeftDots', 'BIconChatLeftDotsFill', 'BIconChatLeftFill', 'BIconChatLeftQuote', 'BIconChatLeftQuoteFill', 'BIconChatLeftText', 'BIconChatLeftTextFill', 'BIconChatQuote', 'BIconChatQuoteFill', 'BIconChatRight', 'BIconChatRightDots', 'BIconChatRightDotsFill', 'BIconChatRightFill', 'BIconChatRightQuote', 'BIconChatRightQuoteFill', 'BIconChatRightText', 'BIconChatRightTextFill', 'BIconChatSquare', 'BIconChatSquareDots', 'BIconChatSquareDotsFill', 'BIconChatSquareFill', 'BIconChatSquareQuote', 'BIconChatSquareQuoteFill', 'BIconChatSquareText', 'BIconChatSquareTextFill', 'BIconChatText', 'BIconChatTextFill', 'BIconCheck', 'BIconCheck2', 'BIconCheck2All', 'BIconCheck2Circle', 'BIconCheck2Square', 'BIconCheckAll', 'BIconCheckCircle', 'BIconCheckCircleFill', 'BIconCheckLg', 'BIconCheckSquare', 'BIconCheckSquareFill', 'BIconChevronBarContract', 'BIconChevronBarDown', 'BIconChevronBarExpand', 'BIconChevronBarLeft', 'BIconChevronBarRight', 'BIconChevronBarUp', 'BIconChevronCompactDown', 'BIconChevronCompactLeft', 'BIconChevronCompactRight', 'BIconChevronCompactUp', 'BIconChevronContract', 'BIconChevronDoubleDown', 'BIconChevronDoubleLeft', 'BIconChevronDoubleRight', 'BIconChevronDoubleUp', 'BIconChevronDown', 'BIconChevronExpand', 'BIconChevronLeft', 'BIconChevronRight', 'BIconChevronUp', 'BIconCircle', 'BIconCircleFill', 'BIconCircleHalf', 'BIconCircleSquare', 'BIconClipboard', 'BIconClipboardCheck', 'BIconClipboardData', 'BIconClipboardMinus', 'BIconClipboardPlus', 'BIconClipboardX', 'BIconClock', 'BIconClockFill', 'BIconClockHistory', 'BIconCloud', 'BIconCloudArrowDown', 'BIconCloudArrowDownFill', 'BIconCloudArrowUp', 'BIconCloudArrowUpFill', 'BIconCloudCheck', 'BIconCloudCheckFill', 'BIconCloudDownload', 'BIconCloudDownloadFill', 'BIconCloudDrizzle', 'BIconCloudDrizzleFill', 'BIconCloudFill', 'BIconCloudFog', 'BIconCloudFog2', 'BIconCloudFog2Fill', 'BIconCloudFogFill', 'BIconCloudHail', 'BIconCloudHailFill', 'BIconCloudHaze', 'BIconCloudHaze1', 'BIconCloudHaze2Fill', 'BIconCloudHazeFill', 'BIconCloudLightning', 'BIconCloudLightningFill', 'BIconCloudLightningRain', 'BIconCloudLightningRainFill', 'BIconCloudMinus', 'BIconCloudMinusFill', 'BIconCloudMoon', 'BIconCloudMoonFill', 'BIconCloudPlus', 'BIconCloudPlusFill', 'BIconCloudRain', 'BIconCloudRainFill', 'BIconCloudRainHeavy', 'BIconCloudRainHeavyFill', 'BIconCloudSlash', 'BIconCloudSlashFill', 'BIconCloudSleet', 'BIconCloudSleetFill', 'BIconCloudSnow', 'BIconCloudSnowFill', 'BIconCloudSun', 'BIconCloudSunFill', 'BIconCloudUpload', 'BIconCloudUploadFill', 'BIconClouds', 'BIconCloudsFill', 'BIconCloudy', 'BIconCloudyFill', 'BIconCode', 'BIconCodeSlash', 'BIconCodeSquare', 'BIconCoin', 'BIconCollection', 'BIconCollectionFill', 'BIconCollectionPlay', 'BIconCollectionPlayFill', 'BIconColumns', 'BIconColumnsGap', 'BIconCommand', 'BIconCompass', 'BIconCompassFill', 'BIconCone', 'BIconConeStriped', 'BIconController', 'BIconCpu', 'BIconCpuFill', 'BIconCreditCard', 'BIconCreditCard2Back', 'BIconCreditCard2BackFill', 'BIconCreditCard2Front', 'BIconCreditCard2FrontFill', 'BIconCreditCardFill', 'BIconCrop', 'BIconCup', 'BIconCupFill', 'BIconCupStraw', 'BIconCurrencyBitcoin', 'BIconCurrencyDollar', 'BIconCurrencyEuro', 'BIconCurrencyExchange', 'BIconCurrencyPound', 'BIconCurrencyYen', 'BIconCursor', 'BIconCursorFill', 'BIconCursorText', 'BIconDash', 'BIconDashCircle', 'BIconDashCircleDotted', 'BIconDashCircleFill', 'BIconDashLg', 'BIconDashSquare', 'BIconDashSquareDotted', 'BIconDashSquareFill', 'BIconDiagram2', 'BIconDiagram2Fill', 'BIconDiagram3', 'BIconDiagram3Fill', 'BIconDiamond', 'BIconDiamondFill', 'BIconDiamondHalf', 'BIconDice1', 'BIconDice1Fill', 'BIconDice2', 'BIconDice2Fill', 'BIconDice3', 'BIconDice3Fill', 'BIconDice4', 'BIconDice4Fill', 'BIconDice5', 'BIconDice5Fill', 'BIconDice6', 'BIconDice6Fill', 'BIconDisc', 'BIconDiscFill', 'BIconDiscord', 'BIconDisplay', 'BIconDisplayFill', 'BIconDistributeHorizontal', 'BIconDistributeVertical', 'BIconDoorClosed', 'BIconDoorClosedFill', 'BIconDoorOpen', 'BIconDoorOpenFill', 'BIconDot', 'BIconDownload', 'BIconDroplet', 'BIconDropletFill', 'BIconDropletHalf', 'BIconEarbuds', 'BIconEasel', 'BIconEaselFill', 'BIconEgg', 'BIconEggFill', 'BIconEggFried', 'BIconEject', 'BIconEjectFill', 'BIconEmojiAngry', 'BIconEmojiAngryFill', 'BIconEmojiDizzy', 'BIconEmojiDizzyFill', 'BIconEmojiExpressionless', 'BIconEmojiExpressionlessFill', 'BIconEmojiFrown', 'BIconEmojiFrownFill', 'BIconEmojiHeartEyes', 'BIconEmojiHeartEyesFill', 'BIconEmojiLaughing', 'BIconEmojiLaughingFill', 'BIconEmojiNeutral', 'BIconEmojiNeutralFill', 'BIconEmojiSmile', 'BIconEmojiSmileFill', 'BIconEmojiSmileUpsideDown', 'BIconEmojiSmileUpsideDownFill', 'BIconEmojiSunglasses', 'BIconEmojiSunglassesFill', 'BIconEmojiWink', 'BIconEmojiWinkFill', 'BIconEnvelope', 'BIconEnvelopeFill', 'BIconEnvelopeOpen', 'BIconEnvelopeOpenFill', 'BIconEraser', 'BIconEraserFill', 'BIconExclamation', 'BIconExclamationCircle', 'BIconExclamationCircleFill', 'BIconExclamationDiamond', 'BIconExclamationDiamondFill', 'BIconExclamationLg', 'BIconExclamationOctagon', 'BIconExclamationOctagonFill', 'BIconExclamationSquare', 'BIconExclamationSquareFill', 'BIconExclamationTriangle', 'BIconExclamationTriangleFill', 'BIconExclude', 'BIconEye', 'BIconEyeFill', 'BIconEyeSlash', 'BIconEyeSlashFill', 'BIconEyedropper', 'BIconEyeglasses', 'BIconFacebook', 'BIconFile', 'BIconFileArrowDown', 'BIconFileArrowDownFill', 'BIconFileArrowUp', 'BIconFileArrowUpFill', 'BIconFileBarGraph', 'BIconFileBarGraphFill', 'BIconFileBinary', 'BIconFileBinaryFill', 'BIconFileBreak', 'BIconFileBreakFill', 'BIconFileCheck', 'BIconFileCheckFill', 'BIconFileCode', 'BIconFileCodeFill', 'BIconFileDiff', 'BIconFileDiffFill', 'BIconFileEarmark', 'BIconFileEarmarkArrowDown', 'BIconFileEarmarkArrowDownFill', 'BIconFileEarmarkArrowUp', 'BIconFileEarmarkArrowUpFill', 'BIconFileEarmarkBarGraph', 'BIconFileEarmarkBarGraphFill', 'BIconFileEarmarkBinary', 'BIconFileEarmarkBinaryFill', 'BIconFileEarmarkBreak', 'BIconFileEarmarkBreakFill', 'BIconFileEarmarkCheck', 'BIconFileEarmarkCheckFill', 'BIconFileEarmarkCode', 'BIconFileEarmarkCodeFill', 'BIconFileEarmarkDiff', 'BIconFileEarmarkDiffFill', 'BIconFileEarmarkEasel', 'BIconFileEarmarkEaselFill', 'BIconFileEarmarkExcel', 'BIconFileEarmarkExcelFill', 'BIconFileEarmarkFill', 'BIconFileEarmarkFont', 'BIconFileEarmarkFontFill', 'BIconFileEarmarkImage', 'BIconFileEarmarkImageFill', 'BIconFileEarmarkLock', 'BIconFileEarmarkLock2', 'BIconFileEarmarkLock2Fill', 'BIconFileEarmarkLockFill', 'BIconFileEarmarkMedical', 'BIconFileEarmarkMedicalFill', 'BIconFileEarmarkMinus', 'BIconFileEarmarkMinusFill', 'BIconFileEarmarkMusic', 'BIconFileEarmarkMusicFill', 'BIconFileEarmarkPdf', 'BIconFileEarmarkPdfFill', 'BIconFileEarmarkPerson', 'BIconFileEarmarkPersonFill', 'BIconFileEarmarkPlay', 'BIconFileEarmarkPlayFill', 'BIconFileEarmarkPlus', 'BIconFileEarmarkPlusFill', 'BIconFileEarmarkPost', 'BIconFileEarmarkPostFill', 'BIconFileEarmarkPpt', 'BIconFileEarmarkPptFill', 'BIconFileEarmarkRichtext', 'BIconFileEarmarkRichtextFill', 'BIconFileEarmarkRuled', 'BIconFileEarmarkRuledFill', 'BIconFileEarmarkSlides', 'BIconFileEarmarkSlidesFill', 'BIconFileEarmarkSpreadsheet', 'BIconFileEarmarkSpreadsheetFill', 'BIconFileEarmarkText', 'BIconFileEarmarkTextFill', 'BIconFileEarmarkWord', 'BIconFileEarmarkWordFill', 'BIconFileEarmarkX', 'BIconFileEarmarkXFill', 'BIconFileEarmarkZip', 'BIconFileEarmarkZipFill', 'BIconFileEasel', 'BIconFileEaselFill', 'BIconFileExcel', 'BIconFileExcelFill', 'BIconFileFill', 'BIconFileFont', 'BIconFileFontFill', 'BIconFileImage', 'BIconFileImageFill', 'BIconFileLock', 'BIconFileLock2', 'BIconFileLock2Fill', 'BIconFileLockFill', 'BIconFileMedical', 'BIconFileMedicalFill', 'BIconFileMinus', 'BIconFileMinusFill', 'BIconFileMusic', 'BIconFileMusicFill', 'BIconFilePdf', 'BIconFilePdfFill', 'BIconFilePerson', 'BIconFilePersonFill', 'BIconFilePlay', 'BIconFilePlayFill', 'BIconFilePlus', 'BIconFilePlusFill', 'BIconFilePost', 'BIconFilePostFill', 'BIconFilePpt', 'BIconFilePptFill', 'BIconFileRichtext', 'BIconFileRichtextFill', 'BIconFileRuled', 'BIconFileRuledFill', 'BIconFileSlides', 'BIconFileSlidesFill', 'BIconFileSpreadsheet', 'BIconFileSpreadsheetFill', 'BIconFileText', 'BIconFileTextFill', 'BIconFileWord', 'BIconFileWordFill', 'BIconFileX', 'BIconFileXFill', 'BIconFileZip', 'BIconFileZipFill', 'BIconFiles', 'BIconFilesAlt', 'BIconFilm', 'BIconFilter', 'BIconFilterCircle', 'BIconFilterCircleFill', 'BIconFilterLeft', 'BIconFilterRight', 'BIconFilterSquare', 'BIconFilterSquareFill', 'BIconFlag', 'BIconFlagFill', 'BIconFlower1', 'BIconFlower2', 'BIconFlower3', 'BIconFolder', 'BIconFolder2', 'BIconFolder2Open', 'BIconFolderCheck', 'BIconFolderFill', 'BIconFolderMinus', 'BIconFolderPlus', 'BIconFolderSymlink', 'BIconFolderSymlinkFill', 'BIconFolderX', 'BIconFonts', 'BIconForward', 'BIconForwardFill', 'BIconFront', 'BIconFullscreen', 'BIconFullscreenExit', 'BIconFunnel', 'BIconFunnelFill', 'BIconGear', 'BIconGearFill', 'BIconGearWide', 'BIconGearWideConnected', 'BIconGem', 'BIconGenderAmbiguous', 'BIconGenderFemale', 'BIconGenderMale', 'BIconGenderTrans', 'BIconGeo', 'BIconGeoAlt', 'BIconGeoAltFill', 'BIconGeoFill', 'BIconGift', 'BIconGiftFill', 'BIconGithub', 'BIconGlobe', 'BIconGlobe2', 'BIconGoogle', 'BIconGraphDown', 'BIconGraphUp', 'BIconGrid', 'BIconGrid1x2', 'BIconGrid1x2Fill', 'BIconGrid3x2', 'BIconGrid3x2Gap', 'BIconGrid3x2GapFill', 'BIconGrid3x3', 'BIconGrid3x3Gap', 'BIconGrid3x3GapFill', 'BIconGridFill', 'BIconGripHorizontal', 'BIconGripVertical', 'BIconHammer', 'BIconHandIndex', 'BIconHandIndexFill', 'BIconHandIndexThumb', 'BIconHandIndexThumbFill', 'BIconHandThumbsDown', 'BIconHandThumbsDownFill', 'BIconHandThumbsUp', 'BIconHandThumbsUpFill', 'BIconHandbag', 'BIconHandbagFill', 'BIconHash', 'BIconHdd', 'BIconHddFill', 'BIconHddNetwork', 'BIconHddNetworkFill', 'BIconHddRack', 'BIconHddRackFill', 'BIconHddStack', 'BIconHddStackFill', 'BIconHeadphones', 'BIconHeadset', 'BIconHeadsetVr', 'BIconHeart', 'BIconHeartFill', 'BIconHeartHalf', 'BIconHeptagon', 'BIconHeptagonFill', 'BIconHeptagonHalf', 'BIconHexagon', 'BIconHexagonFill', 'BIconHexagonHalf', 'BIconHourglass', 'BIconHourglassBottom', 'BIconHourglassSplit', 'BIconHourglassTop', 'BIconHouse', 'BIconHouseDoor', 'BIconHouseDoorFill', 'BIconHouseFill', 'BIconHr', 'BIconHurricane', 'BIconImage', 'BIconImageAlt', 'BIconImageFill', 'BIconImages', 'BIconInbox', 'BIconInboxFill', 'BIconInboxes', 'BIconInboxesFill', 'BIconInfo', 'BIconInfoCircle', 'BIconInfoCircleFill', 'BIconInfoLg', 'BIconInfoSquare', 'BIconInfoSquareFill', 'BIconInputCursor', 'BIconInputCursorText', 'BIconInstagram', 'BIconIntersect', 'BIconJournal', 'BIconJournalAlbum', 'BIconJournalArrowDown', 'BIconJournalArrowUp', 'BIconJournalBookmark', 'BIconJournalBookmarkFill', 'BIconJournalCheck', 'BIconJournalCode', 'BIconJournalMedical', 'BIconJournalMinus', 'BIconJournalPlus', 'BIconJournalRichtext', 'BIconJournalText', 'BIconJournalX', 'BIconJournals', 'BIconJoystick', 'BIconJustify', 'BIconJustifyLeft', 'BIconJustifyRight', 'BIconKanban', 'BIconKanbanFill', 'BIconKey', 'BIconKeyFill', 'BIconKeyboard', 'BIconKeyboardFill', 'BIconLadder', 'BIconLamp', 'BIconLampFill', 'BIconLaptop', 'BIconLaptopFill', 'BIconLayerBackward', 'BIconLayerForward', 'BIconLayers', 'BIconLayersFill', 'BIconLayersHalf', 'BIconLayoutSidebar', 'BIconLayoutSidebarInset', 'BIconLayoutSidebarInsetReverse', 'BIconLayoutSidebarReverse', 'BIconLayoutSplit', 'BIconLayoutTextSidebar', 'BIconLayoutTextSidebarReverse', 'BIconLayoutTextWindow', 'BIconLayoutTextWindowReverse', 'BIconLayoutThreeColumns', 'BIconLayoutWtf', 'BIconLifePreserver', 'BIconLightbulb', 'BIconLightbulbFill', 'BIconLightbulbOff', 'BIconLightbulbOffFill', 'BIconLightning', 'BIconLightningCharge', 'BIconLightningChargeFill', 'BIconLightningFill', 'BIconLink', 'BIconLink45deg', 'BIconLinkedin', 'BIconList', 'BIconListCheck', 'BIconListNested', 'BIconListOl', 'BIconListStars', 'BIconListTask', 'BIconListUl', 'BIconLock', 'BIconLockFill', 'BIconMailbox', 'BIconMailbox2', 'BIconMap', 'BIconMapFill', 'BIconMarkdown', 'BIconMarkdownFill', 'BIconMask', 'BIconMastodon', 'BIconMegaphone', 'BIconMegaphoneFill', 'BIconMenuApp', 'BIconMenuAppFill', 'BIconMenuButton', 'BIconMenuButtonFill', 'BIconMenuButtonWide', 'BIconMenuButtonWideFill', 'BIconMenuDown', 'BIconMenuUp', 'BIconMessenger', 'BIconMic', 'BIconMicFill', 'BIconMicMute', 'BIconMicMuteFill', 'BIconMinecart', 'BIconMinecartLoaded', 'BIconMoisture', 'BIconMoon', 'BIconMoonFill', 'BIconMoonStars', 'BIconMoonStarsFill', 'BIconMouse', 'BIconMouse2', 'BIconMouse2Fill', 'BIconMouse3', 'BIconMouse3Fill', 'BIconMouseFill', 'BIconMusicNote', 'BIconMusicNoteBeamed', 'BIconMusicNoteList', 'BIconMusicPlayer', 'BIconMusicPlayerFill', 'BIconNewspaper', 'BIconNodeMinus', 'BIconNodeMinusFill', 'BIconNodePlus', 'BIconNodePlusFill', 'BIconNut', 'BIconNutFill', 'BIconOctagon', 'BIconOctagonFill', 'BIconOctagonHalf', 'BIconOption', 'BIconOutlet', 'BIconPaintBucket', 'BIconPalette', 'BIconPalette2', 'BIconPaletteFill', 'BIconPaperclip', 'BIconParagraph', 'BIconPatchCheck', 'BIconPatchCheckFill', 'BIconPatchExclamation', 'BIconPatchExclamationFill', 'BIconPatchMinus', 'BIconPatchMinusFill', 'BIconPatchPlus', 'BIconPatchPlusFill', 'BIconPatchQuestion', 'BIconPatchQuestionFill', 'BIconPause', 'BIconPauseBtn', 'BIconPauseBtnFill', 'BIconPauseCircle', 'BIconPauseCircleFill', 'BIconPauseFill', 'BIconPeace', 'BIconPeaceFill', 'BIconPen', 'BIconPenFill', 'BIconPencil', 'BIconPencilFill', 'BIconPencilSquare', 'BIconPentagon', 'BIconPentagonFill', 'BIconPentagonHalf', 'BIconPeople', 'BIconPeopleFill', 'BIconPercent', 'BIconPerson', 'BIconPersonBadge', 'BIconPersonBadgeFill', 'BIconPersonBoundingBox', 'BIconPersonCheck', 'BIconPersonCheckFill', 'BIconPersonCircle', 'BIconPersonDash', 'BIconPersonDashFill', 'BIconPersonFill', 'BIconPersonLinesFill', 'BIconPersonPlus', 'BIconPersonPlusFill', 'BIconPersonSquare', 'BIconPersonX', 'BIconPersonXFill', 'BIconPhone', 'BIconPhoneFill', 'BIconPhoneLandscape', 'BIconPhoneLandscapeFill', 'BIconPhoneVibrate', 'BIconPhoneVibrateFill', 'BIconPieChart', 'BIconPieChartFill', 'BIconPiggyBank', 'BIconPiggyBankFill', 'BIconPin', 'BIconPinAngle', 'BIconPinAngleFill', 'BIconPinFill', 'BIconPinMap', 'BIconPinMapFill', 'BIconPip', 'BIconPipFill', 'BIconPlay', 'BIconPlayBtn', 'BIconPlayBtnFill', 'BIconPlayCircle', 'BIconPlayCircleFill', 'BIconPlayFill', 'BIconPlug', 'BIconPlugFill', 'BIconPlus', 'BIconPlusCircle', 'BIconPlusCircleDotted', 'BIconPlusCircleFill', 'BIconPlusLg', 'BIconPlusSquare', 'BIconPlusSquareDotted', 'BIconPlusSquareFill', 'BIconPower', 'BIconPrinter', 'BIconPrinterFill', 'BIconPuzzle', 'BIconPuzzleFill', 'BIconQuestion', 'BIconQuestionCircle', 'BIconQuestionCircleFill', 'BIconQuestionDiamond', 'BIconQuestionDiamondFill', 'BIconQuestionLg', 'BIconQuestionOctagon', 'BIconQuestionOctagonFill', 'BIconQuestionSquare', 'BIconQuestionSquareFill', 'BIconRainbow', 'BIconReceipt', 'BIconReceiptCutoff', 'BIconReception0', 'BIconReception1', 'BIconReception2', 'BIconReception3', 'BIconReception4', 'BIconRecord', 'BIconRecord2', 'BIconRecord2Fill', 'BIconRecordBtn', 'BIconRecordBtnFill', 'BIconRecordCircle', 'BIconRecordCircleFill', 'BIconRecordFill', 'BIconRecycle', 'BIconReddit', 'BIconReply', 'BIconReplyAll', 'BIconReplyAllFill', 'BIconReplyFill', 'BIconRss', 'BIconRssFill', 'BIconRulers', 'BIconSafe', 'BIconSafe2', 'BIconSafe2Fill', 'BIconSafeFill', 'BIconSave', 'BIconSave2', 'BIconSave2Fill', 'BIconSaveFill', 'BIconScissors', 'BIconScrewdriver', 'BIconSdCard', 'BIconSdCardFill', 'BIconSearch', 'BIconSegmentedNav', 'BIconServer', 'BIconShare', 'BIconShareFill', 'BIconShield', 'BIconShieldCheck', 'BIconShieldExclamation', 'BIconShieldFill', 'BIconShieldFillCheck', 'BIconShieldFillExclamation', 'BIconShieldFillMinus', 'BIconShieldFillPlus', 'BIconShieldFillX', 'BIconShieldLock', 'BIconShieldLockFill', 'BIconShieldMinus', 'BIconShieldPlus', 'BIconShieldShaded', 'BIconShieldSlash', 'BIconShieldSlashFill', 'BIconShieldX', 'BIconShift', 'BIconShiftFill', 'BIconShop', 'BIconShopWindow', 'BIconShuffle', 'BIconSignpost', 'BIconSignpost2', 'BIconSignpost2Fill', 'BIconSignpostFill', 'BIconSignpostSplit', 'BIconSignpostSplitFill', 'BIconSim', 'BIconSimFill', 'BIconSkipBackward', 'BIconSkipBackwardBtn', 'BIconSkipBackwardBtnFill', 'BIconSkipBackwardCircle', 'BIconSkipBackwardCircleFill', 'BIconSkipBackwardFill', 'BIconSkipEnd', 'BIconSkipEndBtn', 'BIconSkipEndBtnFill', 'BIconSkipEndCircle', 'BIconSkipEndCircleFill', 'BIconSkipEndFill', 'BIconSkipForward', 'BIconSkipForwardBtn', 'BIconSkipForwardBtnFill', 'BIconSkipForwardCircle', 'BIconSkipForwardCircleFill', 'BIconSkipForwardFill', 'BIconSkipStart', 'BIconSkipStartBtn', 'BIconSkipStartBtnFill', 'BIconSkipStartCircle', 'BIconSkipStartCircleFill', 'BIconSkipStartFill', 'BIconSkype', 'BIconSlack', 'BIconSlash', 'BIconSlashCircle', 'BIconSlashCircleFill', 'BIconSlashLg', 'BIconSlashSquare', 'BIconSlashSquareFill', 'BIconSliders', 'BIconSmartwatch', 'BIconSnow', 'BIconSnow2', 'BIconSnow3', 'BIconSortAlphaDown', 'BIconSortAlphaDownAlt', 'BIconSortAlphaUp', 'BIconSortAlphaUpAlt', 'BIconSortDown', 'BIconSortDownAlt', 'BIconSortNumericDown', 'BIconSortNumericDownAlt', 'BIconSortNumericUp', 'BIconSortNumericUpAlt', 'BIconSortUp', 'BIconSortUpAlt', 'BIconSoundwave', 'BIconSpeaker', 'BIconSpeakerFill', 'BIconSpeedometer', 'BIconSpeedometer2', 'BIconSpellcheck', 'BIconSquare', 'BIconSquareFill', 'BIconSquareHalf', 'BIconStack', 'BIconStar', 'BIconStarFill', 'BIconStarHalf', 'BIconStars', 'BIconStickies', 'BIconStickiesFill', 'BIconSticky', 'BIconStickyFill', 'BIconStop', 'BIconStopBtn', 'BIconStopBtnFill', 'BIconStopCircle', 'BIconStopCircleFill', 'BIconStopFill', 'BIconStoplights', 'BIconStoplightsFill', 'BIconStopwatch', 'BIconStopwatchFill', 'BIconSubtract', 'BIconSuitClub', 'BIconSuitClubFill', 'BIconSuitDiamond', 'BIconSuitDiamondFill', 'BIconSuitHeart', 'BIconSuitHeartFill', 'BIconSuitSpade', 'BIconSuitSpadeFill', 'BIconSun', 'BIconSunFill', 'BIconSunglasses', 'BIconSunrise', 'BIconSunriseFill', 'BIconSunset', 'BIconSunsetFill', 'BIconSymmetryHorizontal', 'BIconSymmetryVertical', 'BIconTable', 'BIconTablet', 'BIconTabletFill', 'BIconTabletLandscape', 'BIconTabletLandscapeFill', 'BIconTag', 'BIconTagFill', 'BIconTags', 'BIconTagsFill', 'BIconTelegram', 'BIconTelephone', 'BIconTelephoneFill', 'BIconTelephoneForward', 'BIconTelephoneForwardFill', 'BIconTelephoneInbound', 'BIconTelephoneInboundFill', 'BIconTelephoneMinus', 'BIconTelephoneMinusFill', 'BIconTelephoneOutbound', 'BIconTelephoneOutboundFill', 'BIconTelephonePlus', 'BIconTelephonePlusFill', 'BIconTelephoneX', 'BIconTelephoneXFill', 'BIconTerminal', 'BIconTerminalFill', 'BIconTextCenter', 'BIconTextIndentLeft', 'BIconTextIndentRight', 'BIconTextLeft', 'BIconTextParagraph', 'BIconTextRight', 'BIconTextarea', 'BIconTextareaResize', 'BIconTextareaT', 'BIconThermometer', 'BIconThermometerHalf', 'BIconThermometerHigh', 'BIconThermometerLow', 'BIconThermometerSnow', 'BIconThermometerSun', 'BIconThreeDots', 'BIconThreeDotsVertical', 'BIconToggle2Off', 'BIconToggle2On', 'BIconToggleOff', 'BIconToggleOn', 'BIconToggles', 'BIconToggles2', 'BIconTools', 'BIconTornado', 'BIconTranslate', 'BIconTrash', 'BIconTrash2', 'BIconTrash2Fill', 'BIconTrashFill', 'BIconTree', 'BIconTreeFill', 'BIconTriangle', 'BIconTriangleFill', 'BIconTriangleHalf', 'BIconTrophy', 'BIconTrophyFill', 'BIconTropicalStorm', 'BIconTruck', 'BIconTruckFlatbed', 'BIconTsunami', 'BIconTv', 'BIconTvFill', 'BIconTwitch', 'BIconTwitter', 'BIconType', 'BIconTypeBold', 'BIconTypeH1', 'BIconTypeH2', 'BIconTypeH3', 'BIconTypeItalic', 'BIconTypeStrikethrough', 'BIconTypeUnderline', 'BIconUiChecks', 'BIconUiChecksGrid', 'BIconUiRadios', 'BIconUiRadiosGrid', 'BIconUmbrella', 'BIconUmbrellaFill', 'BIconUnion', 'BIconUnlock', 'BIconUnlockFill', 'BIconUpc', 'BIconUpcScan', 'BIconUpload', 'BIconVectorPen', 'BIconViewList', 'BIconViewStacked', 'BIconVinyl', 'BIconVinylFill', 'BIconVoicemail', 'BIconVolumeDown', 'BIconVolumeDownFill', 'BIconVolumeMute', 'BIconVolumeMuteFill', 'BIconVolumeOff', 'BIconVolumeOffFill', 'BIconVolumeUp', 'BIconVolumeUpFill', 'BIconVr', 'BIconWallet', 'BIconWallet2', 'BIconWalletFill', 'BIconWatch', 'BIconWater', 'BIconWhatsapp', 'BIconWifi', 'BIconWifi1', 'BIconWifi2', 'BIconWifiOff', 'BIconWind', 'BIconWindow', 'BIconWindowDock', 'BIconWindowSidebar', 'BIconWrench', 'BIconX', 'BIconXCircle', 'BIconXCircleFill', 'BIconXDiamond', 'BIconXDiamondFill', 'BIconXLg', 'BIconXOctagon', 'BIconXOctagonFill', 'BIconXSquare', 'BIconXSquareFill', 'BIconYoutube', 'BIconZoomIn', 'BIconZoomOut']; // Export the icons plugin

export var IconsPlugin = /*#__PURE__*/pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon: BIcon,
    // Icon stacking component
    BIconstack: BIconstack,
    // BootstrapVue custom icon components
    BIconBlank: BIconBlank,
    // Bootstrap icon components
    BIconAlarm: BIconAlarm,
    BIconAlarmFill: BIconAlarmFill,
    BIconAlignBottom: BIconAlignBottom,
    BIconAlignCenter: BIconAlignCenter,
    BIconAlignEnd: BIconAlignEnd,
    BIconAlignMiddle: BIconAlignMiddle,
    BIconAlignStart: BIconAlignStart,
    BIconAlignTop: BIconAlignTop,
    BIconAlt: BIconAlt,
    BIconApp: BIconApp,
    BIconAppIndicator: BIconAppIndicator,
    BIconArchive: BIconArchive,
    BIconArchiveFill: BIconArchiveFill,
    BIconArrow90degDown: BIconArrow90degDown,
    BIconArrow90degLeft: BIconArrow90degLeft,
    BIconArrow90degRight: BIconArrow90degRight,
    BIconArrow90degUp: BIconArrow90degUp,
    BIconArrowBarDown: BIconArrowBarDown,
    BIconArrowBarLeft: BIconArrowBarLeft,
    BIconArrowBarRight: BIconArrowBarRight,
    BIconArrowBarUp: BIconArrowBarUp,
    BIconArrowClockwise: BIconArrowClockwise,
    BIconArrowCounterclockwise: BIconArrowCounterclockwise,
    BIconArrowDown: BIconArrowDown,
    BIconArrowDownCircle: BIconArrowDownCircle,
    BIconArrowDownCircleFill: BIconArrowDownCircleFill,
    BIconArrowDownLeft: BIconArrowDownLeft,
    BIconArrowDownLeftCircle: BIconArrowDownLeftCircle,
    BIconArrowDownLeftCircleFill: BIconArrowDownLeftCircleFill,
    BIconArrowDownLeftSquare: BIconArrowDownLeftSquare,
    BIconArrowDownLeftSquareFill: BIconArrowDownLeftSquareFill,
    BIconArrowDownRight: BIconArrowDownRight,
    BIconArrowDownRightCircle: BIconArrowDownRightCircle,
    BIconArrowDownRightCircleFill: BIconArrowDownRightCircleFill,
    BIconArrowDownRightSquare: BIconArrowDownRightSquare,
    BIconArrowDownRightSquareFill: BIconArrowDownRightSquareFill,
    BIconArrowDownShort: BIconArrowDownShort,
    BIconArrowDownSquare: BIconArrowDownSquare,
    BIconArrowDownSquareFill: BIconArrowDownSquareFill,
    BIconArrowDownUp: BIconArrowDownUp,
    BIconArrowLeft: BIconArrowLeft,
    BIconArrowLeftCircle: BIconArrowLeftCircle,
    BIconArrowLeftCircleFill: BIconArrowLeftCircleFill,
    BIconArrowLeftRight: BIconArrowLeftRight,
    BIconArrowLeftShort: BIconArrowLeftShort,
    BIconArrowLeftSquare: BIconArrowLeftSquare,
    BIconArrowLeftSquareFill: BIconArrowLeftSquareFill,
    BIconArrowRepeat: BIconArrowRepeat,
    BIconArrowReturnLeft: BIconArrowReturnLeft,
    BIconArrowReturnRight: BIconArrowReturnRight,
    BIconArrowRight: BIconArrowRight,
    BIconArrowRightCircle: BIconArrowRightCircle,
    BIconArrowRightCircleFill: BIconArrowRightCircleFill,
    BIconArrowRightShort: BIconArrowRightShort,
    BIconArrowRightSquare: BIconArrowRightSquare,
    BIconArrowRightSquareFill: BIconArrowRightSquareFill,
    BIconArrowUp: BIconArrowUp,
    BIconArrowUpCircle: BIconArrowUpCircle,
    BIconArrowUpCircleFill: BIconArrowUpCircleFill,
    BIconArrowUpLeft: BIconArrowUpLeft,
    BIconArrowUpLeftCircle: BIconArrowUpLeftCircle,
    BIconArrowUpLeftCircleFill: BIconArrowUpLeftCircleFill,
    BIconArrowUpLeftSquare: BIconArrowUpLeftSquare,
    BIconArrowUpLeftSquareFill: BIconArrowUpLeftSquareFill,
    BIconArrowUpRight: BIconArrowUpRight,
    BIconArrowUpRightCircle: BIconArrowUpRightCircle,
    BIconArrowUpRightCircleFill: BIconArrowUpRightCircleFill,
    BIconArrowUpRightSquare: BIconArrowUpRightSquare,
    BIconArrowUpRightSquareFill: BIconArrowUpRightSquareFill,
    BIconArrowUpShort: BIconArrowUpShort,
    BIconArrowUpSquare: BIconArrowUpSquare,
    BIconArrowUpSquareFill: BIconArrowUpSquareFill,
    BIconArrowsAngleContract: BIconArrowsAngleContract,
    BIconArrowsAngleExpand: BIconArrowsAngleExpand,
    BIconArrowsCollapse: BIconArrowsCollapse,
    BIconArrowsExpand: BIconArrowsExpand,
    BIconArrowsFullscreen: BIconArrowsFullscreen,
    BIconArrowsMove: BIconArrowsMove,
    BIconAspectRatio: BIconAspectRatio,
    BIconAspectRatioFill: BIconAspectRatioFill,
    BIconAsterisk: BIconAsterisk,
    BIconAt: BIconAt,
    BIconAward: BIconAward,
    BIconAwardFill: BIconAwardFill,
    BIconBack: BIconBack,
    BIconBackspace: BIconBackspace,
    BIconBackspaceFill: BIconBackspaceFill,
    BIconBackspaceReverse: BIconBackspaceReverse,
    BIconBackspaceReverseFill: BIconBackspaceReverseFill,
    BIconBadge3d: BIconBadge3d,
    BIconBadge3dFill: BIconBadge3dFill,
    BIconBadge4k: BIconBadge4k,
    BIconBadge4kFill: BIconBadge4kFill,
    BIconBadge8k: BIconBadge8k,
    BIconBadge8kFill: BIconBadge8kFill,
    BIconBadgeAd: BIconBadgeAd,
    BIconBadgeAdFill: BIconBadgeAdFill,
    BIconBadgeAr: BIconBadgeAr,
    BIconBadgeArFill: BIconBadgeArFill,
    BIconBadgeCc: BIconBadgeCc,
    BIconBadgeCcFill: BIconBadgeCcFill,
    BIconBadgeHd: BIconBadgeHd,
    BIconBadgeHdFill: BIconBadgeHdFill,
    BIconBadgeTm: BIconBadgeTm,
    BIconBadgeTmFill: BIconBadgeTmFill,
    BIconBadgeVo: BIconBadgeVo,
    BIconBadgeVoFill: BIconBadgeVoFill,
    BIconBadgeVr: BIconBadgeVr,
    BIconBadgeVrFill: BIconBadgeVrFill,
    BIconBadgeWc: BIconBadgeWc,
    BIconBadgeWcFill: BIconBadgeWcFill,
    BIconBag: BIconBag,
    BIconBagCheck: BIconBagCheck,
    BIconBagCheckFill: BIconBagCheckFill,
    BIconBagDash: BIconBagDash,
    BIconBagDashFill: BIconBagDashFill,
    BIconBagFill: BIconBagFill,
    BIconBagPlus: BIconBagPlus,
    BIconBagPlusFill: BIconBagPlusFill,
    BIconBagX: BIconBagX,
    BIconBagXFill: BIconBagXFill,
    BIconBank: BIconBank,
    BIconBank2: BIconBank2,
    BIconBarChart: BIconBarChart,
    BIconBarChartFill: BIconBarChartFill,
    BIconBarChartLine: BIconBarChartLine,
    BIconBarChartLineFill: BIconBarChartLineFill,
    BIconBarChartSteps: BIconBarChartSteps,
    BIconBasket: BIconBasket,
    BIconBasket2: BIconBasket2,
    BIconBasket2Fill: BIconBasket2Fill,
    BIconBasket3: BIconBasket3,
    BIconBasket3Fill: BIconBasket3Fill,
    BIconBasketFill: BIconBasketFill,
    BIconBattery: BIconBattery,
    BIconBatteryCharging: BIconBatteryCharging,
    BIconBatteryFull: BIconBatteryFull,
    BIconBatteryHalf: BIconBatteryHalf,
    BIconBell: BIconBell,
    BIconBellFill: BIconBellFill,
    BIconBellSlash: BIconBellSlash,
    BIconBellSlashFill: BIconBellSlashFill,
    BIconBezier: BIconBezier,
    BIconBezier2: BIconBezier2,
    BIconBicycle: BIconBicycle,
    BIconBinoculars: BIconBinoculars,
    BIconBinocularsFill: BIconBinocularsFill,
    BIconBlockquoteLeft: BIconBlockquoteLeft,
    BIconBlockquoteRight: BIconBlockquoteRight,
    BIconBook: BIconBook,
    BIconBookFill: BIconBookFill,
    BIconBookHalf: BIconBookHalf,
    BIconBookmark: BIconBookmark,
    BIconBookmarkCheck: BIconBookmarkCheck,
    BIconBookmarkCheckFill: BIconBookmarkCheckFill,
    BIconBookmarkDash: BIconBookmarkDash,
    BIconBookmarkDashFill: BIconBookmarkDashFill,
    BIconBookmarkFill: BIconBookmarkFill,
    BIconBookmarkHeart: BIconBookmarkHeart,
    BIconBookmarkHeartFill: BIconBookmarkHeartFill,
    BIconBookmarkPlus: BIconBookmarkPlus,
    BIconBookmarkPlusFill: BIconBookmarkPlusFill,
    BIconBookmarkStar: BIconBookmarkStar,
    BIconBookmarkStarFill: BIconBookmarkStarFill,
    BIconBookmarkX: BIconBookmarkX,
    BIconBookmarkXFill: BIconBookmarkXFill,
    BIconBookmarks: BIconBookmarks,
    BIconBookmarksFill: BIconBookmarksFill,
    BIconBookshelf: BIconBookshelf,
    BIconBootstrap: BIconBootstrap,
    BIconBootstrapFill: BIconBootstrapFill,
    BIconBootstrapReboot: BIconBootstrapReboot,
    BIconBorder: BIconBorder,
    BIconBorderAll: BIconBorderAll,
    BIconBorderBottom: BIconBorderBottom,
    BIconBorderCenter: BIconBorderCenter,
    BIconBorderInner: BIconBorderInner,
    BIconBorderLeft: BIconBorderLeft,
    BIconBorderMiddle: BIconBorderMiddle,
    BIconBorderOuter: BIconBorderOuter,
    BIconBorderRight: BIconBorderRight,
    BIconBorderStyle: BIconBorderStyle,
    BIconBorderTop: BIconBorderTop,
    BIconBorderWidth: BIconBorderWidth,
    BIconBoundingBox: BIconBoundingBox,
    BIconBoundingBoxCircles: BIconBoundingBoxCircles,
    BIconBox: BIconBox,
    BIconBoxArrowDown: BIconBoxArrowDown,
    BIconBoxArrowDownLeft: BIconBoxArrowDownLeft,
    BIconBoxArrowDownRight: BIconBoxArrowDownRight,
    BIconBoxArrowInDown: BIconBoxArrowInDown,
    BIconBoxArrowInDownLeft: BIconBoxArrowInDownLeft,
    BIconBoxArrowInDownRight: BIconBoxArrowInDownRight,
    BIconBoxArrowInLeft: BIconBoxArrowInLeft,
    BIconBoxArrowInRight: BIconBoxArrowInRight,
    BIconBoxArrowInUp: BIconBoxArrowInUp,
    BIconBoxArrowInUpLeft: BIconBoxArrowInUpLeft,
    BIconBoxArrowInUpRight: BIconBoxArrowInUpRight,
    BIconBoxArrowLeft: BIconBoxArrowLeft,
    BIconBoxArrowRight: BIconBoxArrowRight,
    BIconBoxArrowUp: BIconBoxArrowUp,
    BIconBoxArrowUpLeft: BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight: BIconBoxArrowUpRight,
    BIconBoxSeam: BIconBoxSeam,
    BIconBraces: BIconBraces,
    BIconBricks: BIconBricks,
    BIconBriefcase: BIconBriefcase,
    BIconBriefcaseFill: BIconBriefcaseFill,
    BIconBrightnessAltHigh: BIconBrightnessAltHigh,
    BIconBrightnessAltHighFill: BIconBrightnessAltHighFill,
    BIconBrightnessAltLow: BIconBrightnessAltLow,
    BIconBrightnessAltLowFill: BIconBrightnessAltLowFill,
    BIconBrightnessHigh: BIconBrightnessHigh,
    BIconBrightnessHighFill: BIconBrightnessHighFill,
    BIconBrightnessLow: BIconBrightnessLow,
    BIconBrightnessLowFill: BIconBrightnessLowFill,
    BIconBroadcast: BIconBroadcast,
    BIconBroadcastPin: BIconBroadcastPin,
    BIconBrush: BIconBrush,
    BIconBrushFill: BIconBrushFill,
    BIconBucket: BIconBucket,
    BIconBucketFill: BIconBucketFill,
    BIconBug: BIconBug,
    BIconBugFill: BIconBugFill,
    BIconBuilding: BIconBuilding,
    BIconBullseye: BIconBullseye,
    BIconCalculator: BIconCalculator,
    BIconCalculatorFill: BIconCalculatorFill,
    BIconCalendar: BIconCalendar,
    BIconCalendar2: BIconCalendar2,
    BIconCalendar2Check: BIconCalendar2Check,
    BIconCalendar2CheckFill: BIconCalendar2CheckFill,
    BIconCalendar2Date: BIconCalendar2Date,
    BIconCalendar2DateFill: BIconCalendar2DateFill,
    BIconCalendar2Day: BIconCalendar2Day,
    BIconCalendar2DayFill: BIconCalendar2DayFill,
    BIconCalendar2Event: BIconCalendar2Event,
    BIconCalendar2EventFill: BIconCalendar2EventFill,
    BIconCalendar2Fill: BIconCalendar2Fill,
    BIconCalendar2Minus: BIconCalendar2Minus,
    BIconCalendar2MinusFill: BIconCalendar2MinusFill,
    BIconCalendar2Month: BIconCalendar2Month,
    BIconCalendar2MonthFill: BIconCalendar2MonthFill,
    BIconCalendar2Plus: BIconCalendar2Plus,
    BIconCalendar2PlusFill: BIconCalendar2PlusFill,
    BIconCalendar2Range: BIconCalendar2Range,
    BIconCalendar2RangeFill: BIconCalendar2RangeFill,
    BIconCalendar2Week: BIconCalendar2Week,
    BIconCalendar2WeekFill: BIconCalendar2WeekFill,
    BIconCalendar2X: BIconCalendar2X,
    BIconCalendar2XFill: BIconCalendar2XFill,
    BIconCalendar3: BIconCalendar3,
    BIconCalendar3Event: BIconCalendar3Event,
    BIconCalendar3EventFill: BIconCalendar3EventFill,
    BIconCalendar3Fill: BIconCalendar3Fill,
    BIconCalendar3Range: BIconCalendar3Range,
    BIconCalendar3RangeFill: BIconCalendar3RangeFill,
    BIconCalendar3Week: BIconCalendar3Week,
    BIconCalendar3WeekFill: BIconCalendar3WeekFill,
    BIconCalendar4: BIconCalendar4,
    BIconCalendar4Event: BIconCalendar4Event,
    BIconCalendar4Range: BIconCalendar4Range,
    BIconCalendar4Week: BIconCalendar4Week,
    BIconCalendarCheck: BIconCalendarCheck,
    BIconCalendarCheckFill: BIconCalendarCheckFill,
    BIconCalendarDate: BIconCalendarDate,
    BIconCalendarDateFill: BIconCalendarDateFill,
    BIconCalendarDay: BIconCalendarDay,
    BIconCalendarDayFill: BIconCalendarDayFill,
    BIconCalendarEvent: BIconCalendarEvent,
    BIconCalendarEventFill: BIconCalendarEventFill,
    BIconCalendarFill: BIconCalendarFill,
    BIconCalendarMinus: BIconCalendarMinus,
    BIconCalendarMinusFill: BIconCalendarMinusFill,
    BIconCalendarMonth: BIconCalendarMonth,
    BIconCalendarMonthFill: BIconCalendarMonthFill,
    BIconCalendarPlus: BIconCalendarPlus,
    BIconCalendarPlusFill: BIconCalendarPlusFill,
    BIconCalendarRange: BIconCalendarRange,
    BIconCalendarRangeFill: BIconCalendarRangeFill,
    BIconCalendarWeek: BIconCalendarWeek,
    BIconCalendarWeekFill: BIconCalendarWeekFill,
    BIconCalendarX: BIconCalendarX,
    BIconCalendarXFill: BIconCalendarXFill,
    BIconCamera: BIconCamera,
    BIconCamera2: BIconCamera2,
    BIconCameraFill: BIconCameraFill,
    BIconCameraReels: BIconCameraReels,
    BIconCameraReelsFill: BIconCameraReelsFill,
    BIconCameraVideo: BIconCameraVideo,
    BIconCameraVideoFill: BIconCameraVideoFill,
    BIconCameraVideoOff: BIconCameraVideoOff,
    BIconCameraVideoOffFill: BIconCameraVideoOffFill,
    BIconCapslock: BIconCapslock,
    BIconCapslockFill: BIconCapslockFill,
    BIconCardChecklist: BIconCardChecklist,
    BIconCardHeading: BIconCardHeading,
    BIconCardImage: BIconCardImage,
    BIconCardList: BIconCardList,
    BIconCardText: BIconCardText,
    BIconCaretDown: BIconCaretDown,
    BIconCaretDownFill: BIconCaretDownFill,
    BIconCaretDownSquare: BIconCaretDownSquare,
    BIconCaretDownSquareFill: BIconCaretDownSquareFill,
    BIconCaretLeft: BIconCaretLeft,
    BIconCaretLeftFill: BIconCaretLeftFill,
    BIconCaretLeftSquare: BIconCaretLeftSquare,
    BIconCaretLeftSquareFill: BIconCaretLeftSquareFill,
    BIconCaretRight: BIconCaretRight,
    BIconCaretRightFill: BIconCaretRightFill,
    BIconCaretRightSquare: BIconCaretRightSquare,
    BIconCaretRightSquareFill: BIconCaretRightSquareFill,
    BIconCaretUp: BIconCaretUp,
    BIconCaretUpFill: BIconCaretUpFill,
    BIconCaretUpSquare: BIconCaretUpSquare,
    BIconCaretUpSquareFill: BIconCaretUpSquareFill,
    BIconCart: BIconCart,
    BIconCart2: BIconCart2,
    BIconCart3: BIconCart3,
    BIconCart4: BIconCart4,
    BIconCartCheck: BIconCartCheck,
    BIconCartCheckFill: BIconCartCheckFill,
    BIconCartDash: BIconCartDash,
    BIconCartDashFill: BIconCartDashFill,
    BIconCartFill: BIconCartFill,
    BIconCartPlus: BIconCartPlus,
    BIconCartPlusFill: BIconCartPlusFill,
    BIconCartX: BIconCartX,
    BIconCartXFill: BIconCartXFill,
    BIconCash: BIconCash,
    BIconCashCoin: BIconCashCoin,
    BIconCashStack: BIconCashStack,
    BIconCast: BIconCast,
    BIconChat: BIconChat,
    BIconChatDots: BIconChatDots,
    BIconChatDotsFill: BIconChatDotsFill,
    BIconChatFill: BIconChatFill,
    BIconChatLeft: BIconChatLeft,
    BIconChatLeftDots: BIconChatLeftDots,
    BIconChatLeftDotsFill: BIconChatLeftDotsFill,
    BIconChatLeftFill: BIconChatLeftFill,
    BIconChatLeftQuote: BIconChatLeftQuote,
    BIconChatLeftQuoteFill: BIconChatLeftQuoteFill,
    BIconChatLeftText: BIconChatLeftText,
    BIconChatLeftTextFill: BIconChatLeftTextFill,
    BIconChatQuote: BIconChatQuote,
    BIconChatQuoteFill: BIconChatQuoteFill,
    BIconChatRight: BIconChatRight,
    BIconChatRightDots: BIconChatRightDots,
    BIconChatRightDotsFill: BIconChatRightDotsFill,
    BIconChatRightFill: BIconChatRightFill,
    BIconChatRightQuote: BIconChatRightQuote,
    BIconChatRightQuoteFill: BIconChatRightQuoteFill,
    BIconChatRightText: BIconChatRightText,
    BIconChatRightTextFill: BIconChatRightTextFill,
    BIconChatSquare: BIconChatSquare,
    BIconChatSquareDots: BIconChatSquareDots,
    BIconChatSquareDotsFill: BIconChatSquareDotsFill,
    BIconChatSquareFill: BIconChatSquareFill,
    BIconChatSquareQuote: BIconChatSquareQuote,
    BIconChatSquareQuoteFill: BIconChatSquareQuoteFill,
    BIconChatSquareText: BIconChatSquareText,
    BIconChatSquareTextFill: BIconChatSquareTextFill,
    BIconChatText: BIconChatText,
    BIconChatTextFill: BIconChatTextFill,
    BIconCheck: BIconCheck,
    BIconCheck2: BIconCheck2,
    BIconCheck2All: BIconCheck2All,
    BIconCheck2Circle: BIconCheck2Circle,
    BIconCheck2Square: BIconCheck2Square,
    BIconCheckAll: BIconCheckAll,
    BIconCheckCircle: BIconCheckCircle,
    BIconCheckCircleFill: BIconCheckCircleFill,
    BIconCheckLg: BIconCheckLg,
    BIconCheckSquare: BIconCheckSquare,
    BIconCheckSquareFill: BIconCheckSquareFill,
    BIconChevronBarContract: BIconChevronBarContract,
    BIconChevronBarDown: BIconChevronBarDown,
    BIconChevronBarExpand: BIconChevronBarExpand,
    BIconChevronBarLeft: BIconChevronBarLeft,
    BIconChevronBarRight: BIconChevronBarRight,
    BIconChevronBarUp: BIconChevronBarUp,
    BIconChevronCompactDown: BIconChevronCompactDown,
    BIconChevronCompactLeft: BIconChevronCompactLeft,
    BIconChevronCompactRight: BIconChevronCompactRight,
    BIconChevronCompactUp: BIconChevronCompactUp,
    BIconChevronContract: BIconChevronContract,
    BIconChevronDoubleDown: BIconChevronDoubleDown,
    BIconChevronDoubleLeft: BIconChevronDoubleLeft,
    BIconChevronDoubleRight: BIconChevronDoubleRight,
    BIconChevronDoubleUp: BIconChevronDoubleUp,
    BIconChevronDown: BIconChevronDown,
    BIconChevronExpand: BIconChevronExpand,
    BIconChevronLeft: BIconChevronLeft,
    BIconChevronRight: BIconChevronRight,
    BIconChevronUp: BIconChevronUp,
    BIconCircle: BIconCircle,
    BIconCircleFill: BIconCircleFill,
    BIconCircleHalf: BIconCircleHalf,
    BIconCircleSquare: BIconCircleSquare,
    BIconClipboard: BIconClipboard,
    BIconClipboardCheck: BIconClipboardCheck,
    BIconClipboardData: BIconClipboardData,
    BIconClipboardMinus: BIconClipboardMinus,
    BIconClipboardPlus: BIconClipboardPlus,
    BIconClipboardX: BIconClipboardX,
    BIconClock: BIconClock,
    BIconClockFill: BIconClockFill,
    BIconClockHistory: BIconClockHistory,
    BIconCloud: BIconCloud,
    BIconCloudArrowDown: BIconCloudArrowDown,
    BIconCloudArrowDownFill: BIconCloudArrowDownFill,
    BIconCloudArrowUp: BIconCloudArrowUp,
    BIconCloudArrowUpFill: BIconCloudArrowUpFill,
    BIconCloudCheck: BIconCloudCheck,
    BIconCloudCheckFill: BIconCloudCheckFill,
    BIconCloudDownload: BIconCloudDownload,
    BIconCloudDownloadFill: BIconCloudDownloadFill,
    BIconCloudDrizzle: BIconCloudDrizzle,
    BIconCloudDrizzleFill: BIconCloudDrizzleFill,
    BIconCloudFill: BIconCloudFill,
    BIconCloudFog: BIconCloudFog,
    BIconCloudFog2: BIconCloudFog2,
    BIconCloudFog2Fill: BIconCloudFog2Fill,
    BIconCloudFogFill: BIconCloudFogFill,
    BIconCloudHail: BIconCloudHail,
    BIconCloudHailFill: BIconCloudHailFill,
    BIconCloudHaze: BIconCloudHaze,
    BIconCloudHaze1: BIconCloudHaze1,
    BIconCloudHaze2Fill: BIconCloudHaze2Fill,
    BIconCloudHazeFill: BIconCloudHazeFill,
    BIconCloudLightning: BIconCloudLightning,
    BIconCloudLightningFill: BIconCloudLightningFill,
    BIconCloudLightningRain: BIconCloudLightningRain,
    BIconCloudLightningRainFill: BIconCloudLightningRainFill,
    BIconCloudMinus: BIconCloudMinus,
    BIconCloudMinusFill: BIconCloudMinusFill,
    BIconCloudMoon: BIconCloudMoon,
    BIconCloudMoonFill: BIconCloudMoonFill,
    BIconCloudPlus: BIconCloudPlus,
    BIconCloudPlusFill: BIconCloudPlusFill,
    BIconCloudRain: BIconCloudRain,
    BIconCloudRainFill: BIconCloudRainFill,
    BIconCloudRainHeavy: BIconCloudRainHeavy,
    BIconCloudRainHeavyFill: BIconCloudRainHeavyFill,
    BIconCloudSlash: BIconCloudSlash,
    BIconCloudSlashFill: BIconCloudSlashFill,
    BIconCloudSleet: BIconCloudSleet,
    BIconCloudSleetFill: BIconCloudSleetFill,
    BIconCloudSnow: BIconCloudSnow,
    BIconCloudSnowFill: BIconCloudSnowFill,
    BIconCloudSun: BIconCloudSun,
    BIconCloudSunFill: BIconCloudSunFill,
    BIconCloudUpload: BIconCloudUpload,
    BIconCloudUploadFill: BIconCloudUploadFill,
    BIconClouds: BIconClouds,
    BIconCloudsFill: BIconCloudsFill,
    BIconCloudy: BIconCloudy,
    BIconCloudyFill: BIconCloudyFill,
    BIconCode: BIconCode,
    BIconCodeSlash: BIconCodeSlash,
    BIconCodeSquare: BIconCodeSquare,
    BIconCoin: BIconCoin,
    BIconCollection: BIconCollection,
    BIconCollectionFill: BIconCollectionFill,
    BIconCollectionPlay: BIconCollectionPlay,
    BIconCollectionPlayFill: BIconCollectionPlayFill,
    BIconColumns: BIconColumns,
    BIconColumnsGap: BIconColumnsGap,
    BIconCommand: BIconCommand,
    BIconCompass: BIconCompass,
    BIconCompassFill: BIconCompassFill,
    BIconCone: BIconCone,
    BIconConeStriped: BIconConeStriped,
    BIconController: BIconController,
    BIconCpu: BIconCpu,
    BIconCpuFill: BIconCpuFill,
    BIconCreditCard: BIconCreditCard,
    BIconCreditCard2Back: BIconCreditCard2Back,
    BIconCreditCard2BackFill: BIconCreditCard2BackFill,
    BIconCreditCard2Front: BIconCreditCard2Front,
    BIconCreditCard2FrontFill: BIconCreditCard2FrontFill,
    BIconCreditCardFill: BIconCreditCardFill,
    BIconCrop: BIconCrop,
    BIconCup: BIconCup,
    BIconCupFill: BIconCupFill,
    BIconCupStraw: BIconCupStraw,
    BIconCurrencyBitcoin: BIconCurrencyBitcoin,
    BIconCurrencyDollar: BIconCurrencyDollar,
    BIconCurrencyEuro: BIconCurrencyEuro,
    BIconCurrencyExchange: BIconCurrencyExchange,
    BIconCurrencyPound: BIconCurrencyPound,
    BIconCurrencyYen: BIconCurrencyYen,
    BIconCursor: BIconCursor,
    BIconCursorFill: BIconCursorFill,
    BIconCursorText: BIconCursorText,
    BIconDash: BIconDash,
    BIconDashCircle: BIconDashCircle,
    BIconDashCircleDotted: BIconDashCircleDotted,
    BIconDashCircleFill: BIconDashCircleFill,
    BIconDashLg: BIconDashLg,
    BIconDashSquare: BIconDashSquare,
    BIconDashSquareDotted: BIconDashSquareDotted,
    BIconDashSquareFill: BIconDashSquareFill,
    BIconDiagram2: BIconDiagram2,
    BIconDiagram2Fill: BIconDiagram2Fill,
    BIconDiagram3: BIconDiagram3,
    BIconDiagram3Fill: BIconDiagram3Fill,
    BIconDiamond: BIconDiamond,
    BIconDiamondFill: BIconDiamondFill,
    BIconDiamondHalf: BIconDiamondHalf,
    BIconDice1: BIconDice1,
    BIconDice1Fill: BIconDice1Fill,
    BIconDice2: BIconDice2,
    BIconDice2Fill: BIconDice2Fill,
    BIconDice3: BIconDice3,
    BIconDice3Fill: BIconDice3Fill,
    BIconDice4: BIconDice4,
    BIconDice4Fill: BIconDice4Fill,
    BIconDice5: BIconDice5,
    BIconDice5Fill: BIconDice5Fill,
    BIconDice6: BIconDice6,
    BIconDice6Fill: BIconDice6Fill,
    BIconDisc: BIconDisc,
    BIconDiscFill: BIconDiscFill,
    BIconDiscord: BIconDiscord,
    BIconDisplay: BIconDisplay,
    BIconDisplayFill: BIconDisplayFill,
    BIconDistributeHorizontal: BIconDistributeHorizontal,
    BIconDistributeVertical: BIconDistributeVertical,
    BIconDoorClosed: BIconDoorClosed,
    BIconDoorClosedFill: BIconDoorClosedFill,
    BIconDoorOpen: BIconDoorOpen,
    BIconDoorOpenFill: BIconDoorOpenFill,
    BIconDot: BIconDot,
    BIconDownload: BIconDownload,
    BIconDroplet: BIconDroplet,
    BIconDropletFill: BIconDropletFill,
    BIconDropletHalf: BIconDropletHalf,
    BIconEarbuds: BIconEarbuds,
    BIconEasel: BIconEasel,
    BIconEaselFill: BIconEaselFill,
    BIconEgg: BIconEgg,
    BIconEggFill: BIconEggFill,
    BIconEggFried: BIconEggFried,
    BIconEject: BIconEject,
    BIconEjectFill: BIconEjectFill,
    BIconEmojiAngry: BIconEmojiAngry,
    BIconEmojiAngryFill: BIconEmojiAngryFill,
    BIconEmojiDizzy: BIconEmojiDizzy,
    BIconEmojiDizzyFill: BIconEmojiDizzyFill,
    BIconEmojiExpressionless: BIconEmojiExpressionless,
    BIconEmojiExpressionlessFill: BIconEmojiExpressionlessFill,
    BIconEmojiFrown: BIconEmojiFrown,
    BIconEmojiFrownFill: BIconEmojiFrownFill,
    BIconEmojiHeartEyes: BIconEmojiHeartEyes,
    BIconEmojiHeartEyesFill: BIconEmojiHeartEyesFill,
    BIconEmojiLaughing: BIconEmojiLaughing,
    BIconEmojiLaughingFill: BIconEmojiLaughingFill,
    BIconEmojiNeutral: BIconEmojiNeutral,
    BIconEmojiNeutralFill: BIconEmojiNeutralFill,
    BIconEmojiSmile: BIconEmojiSmile,
    BIconEmojiSmileFill: BIconEmojiSmileFill,
    BIconEmojiSmileUpsideDown: BIconEmojiSmileUpsideDown,
    BIconEmojiSmileUpsideDownFill: BIconEmojiSmileUpsideDownFill,
    BIconEmojiSunglasses: BIconEmojiSunglasses,
    BIconEmojiSunglassesFill: BIconEmojiSunglassesFill,
    BIconEmojiWink: BIconEmojiWink,
    BIconEmojiWinkFill: BIconEmojiWinkFill,
    BIconEnvelope: BIconEnvelope,
    BIconEnvelopeFill: BIconEnvelopeFill,
    BIconEnvelopeOpen: BIconEnvelopeOpen,
    BIconEnvelopeOpenFill: BIconEnvelopeOpenFill,
    BIconEraser: BIconEraser,
    BIconEraserFill: BIconEraserFill,
    BIconExclamation: BIconExclamation,
    BIconExclamationCircle: BIconExclamationCircle,
    BIconExclamationCircleFill: BIconExclamationCircleFill,
    BIconExclamationDiamond: BIconExclamationDiamond,
    BIconExclamationDiamondFill: BIconExclamationDiamondFill,
    BIconExclamationLg: BIconExclamationLg,
    BIconExclamationOctagon: BIconExclamationOctagon,
    BIconExclamationOctagonFill: BIconExclamationOctagonFill,
    BIconExclamationSquare: BIconExclamationSquare,
    BIconExclamationSquareFill: BIconExclamationSquareFill,
    BIconExclamationTriangle: BIconExclamationTriangle,
    BIconExclamationTriangleFill: BIconExclamationTriangleFill,
    BIconExclude: BIconExclude,
    BIconEye: BIconEye,
    BIconEyeFill: BIconEyeFill,
    BIconEyeSlash: BIconEyeSlash,
    BIconEyeSlashFill: BIconEyeSlashFill,
    BIconEyedropper: BIconEyedropper,
    BIconEyeglasses: BIconEyeglasses,
    BIconFacebook: BIconFacebook,
    BIconFile: BIconFile,
    BIconFileArrowDown: BIconFileArrowDown,
    BIconFileArrowDownFill: BIconFileArrowDownFill,
    BIconFileArrowUp: BIconFileArrowUp,
    BIconFileArrowUpFill: BIconFileArrowUpFill,
    BIconFileBarGraph: BIconFileBarGraph,
    BIconFileBarGraphFill: BIconFileBarGraphFill,
    BIconFileBinary: BIconFileBinary,
    BIconFileBinaryFill: BIconFileBinaryFill,
    BIconFileBreak: BIconFileBreak,
    BIconFileBreakFill: BIconFileBreakFill,
    BIconFileCheck: BIconFileCheck,
    BIconFileCheckFill: BIconFileCheckFill,
    BIconFileCode: BIconFileCode,
    BIconFileCodeFill: BIconFileCodeFill,
    BIconFileDiff: BIconFileDiff,
    BIconFileDiffFill: BIconFileDiffFill,
    BIconFileEarmark: BIconFileEarmark,
    BIconFileEarmarkArrowDown: BIconFileEarmarkArrowDown,
    BIconFileEarmarkArrowDownFill: BIconFileEarmarkArrowDownFill,
    BIconFileEarmarkArrowUp: BIconFileEarmarkArrowUp,
    BIconFileEarmarkArrowUpFill: BIconFileEarmarkArrowUpFill,
    BIconFileEarmarkBarGraph: BIconFileEarmarkBarGraph,
    BIconFileEarmarkBarGraphFill: BIconFileEarmarkBarGraphFill,
    BIconFileEarmarkBinary: BIconFileEarmarkBinary,
    BIconFileEarmarkBinaryFill: BIconFileEarmarkBinaryFill,
    BIconFileEarmarkBreak: BIconFileEarmarkBreak,
    BIconFileEarmarkBreakFill: BIconFileEarmarkBreakFill,
    BIconFileEarmarkCheck: BIconFileEarmarkCheck,
    BIconFileEarmarkCheckFill: BIconFileEarmarkCheckFill,
    BIconFileEarmarkCode: BIconFileEarmarkCode,
    BIconFileEarmarkCodeFill: BIconFileEarmarkCodeFill,
    BIconFileEarmarkDiff: BIconFileEarmarkDiff,
    BIconFileEarmarkDiffFill: BIconFileEarmarkDiffFill,
    BIconFileEarmarkEasel: BIconFileEarmarkEasel,
    BIconFileEarmarkEaselFill: BIconFileEarmarkEaselFill,
    BIconFileEarmarkExcel: BIconFileEarmarkExcel,
    BIconFileEarmarkExcelFill: BIconFileEarmarkExcelFill,
    BIconFileEarmarkFill: BIconFileEarmarkFill,
    BIconFileEarmarkFont: BIconFileEarmarkFont,
    BIconFileEarmarkFontFill: BIconFileEarmarkFontFill,
    BIconFileEarmarkImage: BIconFileEarmarkImage,
    BIconFileEarmarkImageFill: BIconFileEarmarkImageFill,
    BIconFileEarmarkLock: BIconFileEarmarkLock,
    BIconFileEarmarkLock2: BIconFileEarmarkLock2,
    BIconFileEarmarkLock2Fill: BIconFileEarmarkLock2Fill,
    BIconFileEarmarkLockFill: BIconFileEarmarkLockFill,
    BIconFileEarmarkMedical: BIconFileEarmarkMedical,
    BIconFileEarmarkMedicalFill: BIconFileEarmarkMedicalFill,
    BIconFileEarmarkMinus: BIconFileEarmarkMinus,
    BIconFileEarmarkMinusFill: BIconFileEarmarkMinusFill,
    BIconFileEarmarkMusic: BIconFileEarmarkMusic,
    BIconFileEarmarkMusicFill: BIconFileEarmarkMusicFill,
    BIconFileEarmarkPdf: BIconFileEarmarkPdf,
    BIconFileEarmarkPdfFill: BIconFileEarmarkPdfFill,
    BIconFileEarmarkPerson: BIconFileEarmarkPerson,
    BIconFileEarmarkPersonFill: BIconFileEarmarkPersonFill,
    BIconFileEarmarkPlay: BIconFileEarmarkPlay,
    BIconFileEarmarkPlayFill: BIconFileEarmarkPlayFill,
    BIconFileEarmarkPlus: BIconFileEarmarkPlus,
    BIconFileEarmarkPlusFill: BIconFileEarmarkPlusFill,
    BIconFileEarmarkPost: BIconFileEarmarkPost,
    BIconFileEarmarkPostFill: BIconFileEarmarkPostFill,
    BIconFileEarmarkPpt: BIconFileEarmarkPpt,
    BIconFileEarmarkPptFill: BIconFileEarmarkPptFill,
    BIconFileEarmarkRichtext: BIconFileEarmarkRichtext,
    BIconFileEarmarkRichtextFill: BIconFileEarmarkRichtextFill,
    BIconFileEarmarkRuled: BIconFileEarmarkRuled,
    BIconFileEarmarkRuledFill: BIconFileEarmarkRuledFill,
    BIconFileEarmarkSlides: BIconFileEarmarkSlides,
    BIconFileEarmarkSlidesFill: BIconFileEarmarkSlidesFill,
    BIconFileEarmarkSpreadsheet: BIconFileEarmarkSpreadsheet,
    BIconFileEarmarkSpreadsheetFill: BIconFileEarmarkSpreadsheetFill,
    BIconFileEarmarkText: BIconFileEarmarkText,
    BIconFileEarmarkTextFill: BIconFileEarmarkTextFill,
    BIconFileEarmarkWord: BIconFileEarmarkWord,
    BIconFileEarmarkWordFill: BIconFileEarmarkWordFill,
    BIconFileEarmarkX: BIconFileEarmarkX,
    BIconFileEarmarkXFill: BIconFileEarmarkXFill,
    BIconFileEarmarkZip: BIconFileEarmarkZip,
    BIconFileEarmarkZipFill: BIconFileEarmarkZipFill,
    BIconFileEasel: BIconFileEasel,
    BIconFileEaselFill: BIconFileEaselFill,
    BIconFileExcel: BIconFileExcel,
    BIconFileExcelFill: BIconFileExcelFill,
    BIconFileFill: BIconFileFill,
    BIconFileFont: BIconFileFont,
    BIconFileFontFill: BIconFileFontFill,
    BIconFileImage: BIconFileImage,
    BIconFileImageFill: BIconFileImageFill,
    BIconFileLock: BIconFileLock,
    BIconFileLock2: BIconFileLock2,
    BIconFileLock2Fill: BIconFileLock2Fill,
    BIconFileLockFill: BIconFileLockFill,
    BIconFileMedical: BIconFileMedical,
    BIconFileMedicalFill: BIconFileMedicalFill,
    BIconFileMinus: BIconFileMinus,
    BIconFileMinusFill: BIconFileMinusFill,
    BIconFileMusic: BIconFileMusic,
    BIconFileMusicFill: BIconFileMusicFill,
    BIconFilePdf: BIconFilePdf,
    BIconFilePdfFill: BIconFilePdfFill,
    BIconFilePerson: BIconFilePerson,
    BIconFilePersonFill: BIconFilePersonFill,
    BIconFilePlay: BIconFilePlay,
    BIconFilePlayFill: BIconFilePlayFill,
    BIconFilePlus: BIconFilePlus,
    BIconFilePlusFill: BIconFilePlusFill,
    BIconFilePost: BIconFilePost,
    BIconFilePostFill: BIconFilePostFill,
    BIconFilePpt: BIconFilePpt,
    BIconFilePptFill: BIconFilePptFill,
    BIconFileRichtext: BIconFileRichtext,
    BIconFileRichtextFill: BIconFileRichtextFill,
    BIconFileRuled: BIconFileRuled,
    BIconFileRuledFill: BIconFileRuledFill,
    BIconFileSlides: BIconFileSlides,
    BIconFileSlidesFill: BIconFileSlidesFill,
    BIconFileSpreadsheet: BIconFileSpreadsheet,
    BIconFileSpreadsheetFill: BIconFileSpreadsheetFill,
    BIconFileText: BIconFileText,
    BIconFileTextFill: BIconFileTextFill,
    BIconFileWord: BIconFileWord,
    BIconFileWordFill: BIconFileWordFill,
    BIconFileX: BIconFileX,
    BIconFileXFill: BIconFileXFill,
    BIconFileZip: BIconFileZip,
    BIconFileZipFill: BIconFileZipFill,
    BIconFiles: BIconFiles,
    BIconFilesAlt: BIconFilesAlt,
    BIconFilm: BIconFilm,
    BIconFilter: BIconFilter,
    BIconFilterCircle: BIconFilterCircle,
    BIconFilterCircleFill: BIconFilterCircleFill,
    BIconFilterLeft: BIconFilterLeft,
    BIconFilterRight: BIconFilterRight,
    BIconFilterSquare: BIconFilterSquare,
    BIconFilterSquareFill: BIconFilterSquareFill,
    BIconFlag: BIconFlag,
    BIconFlagFill: BIconFlagFill,
    BIconFlower1: BIconFlower1,
    BIconFlower2: BIconFlower2,
    BIconFlower3: BIconFlower3,
    BIconFolder: BIconFolder,
    BIconFolder2: BIconFolder2,
    BIconFolder2Open: BIconFolder2Open,
    BIconFolderCheck: BIconFolderCheck,
    BIconFolderFill: BIconFolderFill,
    BIconFolderMinus: BIconFolderMinus,
    BIconFolderPlus: BIconFolderPlus,
    BIconFolderSymlink: BIconFolderSymlink,
    BIconFolderSymlinkFill: BIconFolderSymlinkFill,
    BIconFolderX: BIconFolderX,
    BIconFonts: BIconFonts,
    BIconForward: BIconForward,
    BIconForwardFill: BIconForwardFill,
    BIconFront: BIconFront,
    BIconFullscreen: BIconFullscreen,
    BIconFullscreenExit: BIconFullscreenExit,
    BIconFunnel: BIconFunnel,
    BIconFunnelFill: BIconFunnelFill,
    BIconGear: BIconGear,
    BIconGearFill: BIconGearFill,
    BIconGearWide: BIconGearWide,
    BIconGearWideConnected: BIconGearWideConnected,
    BIconGem: BIconGem,
    BIconGenderAmbiguous: BIconGenderAmbiguous,
    BIconGenderFemale: BIconGenderFemale,
    BIconGenderMale: BIconGenderMale,
    BIconGenderTrans: BIconGenderTrans,
    BIconGeo: BIconGeo,
    BIconGeoAlt: BIconGeoAlt,
    BIconGeoAltFill: BIconGeoAltFill,
    BIconGeoFill: BIconGeoFill,
    BIconGift: BIconGift,
    BIconGiftFill: BIconGiftFill,
    BIconGithub: BIconGithub,
    BIconGlobe: BIconGlobe,
    BIconGlobe2: BIconGlobe2,
    BIconGoogle: BIconGoogle,
    BIconGraphDown: BIconGraphDown,
    BIconGraphUp: BIconGraphUp,
    BIconGrid: BIconGrid,
    BIconGrid1x2: BIconGrid1x2,
    BIconGrid1x2Fill: BIconGrid1x2Fill,
    BIconGrid3x2: BIconGrid3x2,
    BIconGrid3x2Gap: BIconGrid3x2Gap,
    BIconGrid3x2GapFill: BIconGrid3x2GapFill,
    BIconGrid3x3: BIconGrid3x3,
    BIconGrid3x3Gap: BIconGrid3x3Gap,
    BIconGrid3x3GapFill: BIconGrid3x3GapFill,
    BIconGridFill: BIconGridFill,
    BIconGripHorizontal: BIconGripHorizontal,
    BIconGripVertical: BIconGripVertical,
    BIconHammer: BIconHammer,
    BIconHandIndex: BIconHandIndex,
    BIconHandIndexFill: BIconHandIndexFill,
    BIconHandIndexThumb: BIconHandIndexThumb,
    BIconHandIndexThumbFill: BIconHandIndexThumbFill,
    BIconHandThumbsDown: BIconHandThumbsDown,
    BIconHandThumbsDownFill: BIconHandThumbsDownFill,
    BIconHandThumbsUp: BIconHandThumbsUp,
    BIconHandThumbsUpFill: BIconHandThumbsUpFill,
    BIconHandbag: BIconHandbag,
    BIconHandbagFill: BIconHandbagFill,
    BIconHash: BIconHash,
    BIconHdd: BIconHdd,
    BIconHddFill: BIconHddFill,
    BIconHddNetwork: BIconHddNetwork,
    BIconHddNetworkFill: BIconHddNetworkFill,
    BIconHddRack: BIconHddRack,
    BIconHddRackFill: BIconHddRackFill,
    BIconHddStack: BIconHddStack,
    BIconHddStackFill: BIconHddStackFill,
    BIconHeadphones: BIconHeadphones,
    BIconHeadset: BIconHeadset,
    BIconHeadsetVr: BIconHeadsetVr,
    BIconHeart: BIconHeart,
    BIconHeartFill: BIconHeartFill,
    BIconHeartHalf: BIconHeartHalf,
    BIconHeptagon: BIconHeptagon,
    BIconHeptagonFill: BIconHeptagonFill,
    BIconHeptagonHalf: BIconHeptagonHalf,
    BIconHexagon: BIconHexagon,
    BIconHexagonFill: BIconHexagonFill,
    BIconHexagonHalf: BIconHexagonHalf,
    BIconHourglass: BIconHourglass,
    BIconHourglassBottom: BIconHourglassBottom,
    BIconHourglassSplit: BIconHourglassSplit,
    BIconHourglassTop: BIconHourglassTop,
    BIconHouse: BIconHouse,
    BIconHouseDoor: BIconHouseDoor,
    BIconHouseDoorFill: BIconHouseDoorFill,
    BIconHouseFill: BIconHouseFill,
    BIconHr: BIconHr,
    BIconHurricane: BIconHurricane,
    BIconImage: BIconImage,
    BIconImageAlt: BIconImageAlt,
    BIconImageFill: BIconImageFill,
    BIconImages: BIconImages,
    BIconInbox: BIconInbox,
    BIconInboxFill: BIconInboxFill,
    BIconInboxes: BIconInboxes,
    BIconInboxesFill: BIconInboxesFill,
    BIconInfo: BIconInfo,
    BIconInfoCircle: BIconInfoCircle,
    BIconInfoCircleFill: BIconInfoCircleFill,
    BIconInfoLg: BIconInfoLg,
    BIconInfoSquare: BIconInfoSquare,
    BIconInfoSquareFill: BIconInfoSquareFill,
    BIconInputCursor: BIconInputCursor,
    BIconInputCursorText: BIconInputCursorText,
    BIconInstagram: BIconInstagram,
    BIconIntersect: BIconIntersect,
    BIconJournal: BIconJournal,
    BIconJournalAlbum: BIconJournalAlbum,
    BIconJournalArrowDown: BIconJournalArrowDown,
    BIconJournalArrowUp: BIconJournalArrowUp,
    BIconJournalBookmark: BIconJournalBookmark,
    BIconJournalBookmarkFill: BIconJournalBookmarkFill,
    BIconJournalCheck: BIconJournalCheck,
    BIconJournalCode: BIconJournalCode,
    BIconJournalMedical: BIconJournalMedical,
    BIconJournalMinus: BIconJournalMinus,
    BIconJournalPlus: BIconJournalPlus,
    BIconJournalRichtext: BIconJournalRichtext,
    BIconJournalText: BIconJournalText,
    BIconJournalX: BIconJournalX,
    BIconJournals: BIconJournals,
    BIconJoystick: BIconJoystick,
    BIconJustify: BIconJustify,
    BIconJustifyLeft: BIconJustifyLeft,
    BIconJustifyRight: BIconJustifyRight,
    BIconKanban: BIconKanban,
    BIconKanbanFill: BIconKanbanFill,
    BIconKey: BIconKey,
    BIconKeyFill: BIconKeyFill,
    BIconKeyboard: BIconKeyboard,
    BIconKeyboardFill: BIconKeyboardFill,
    BIconLadder: BIconLadder,
    BIconLamp: BIconLamp,
    BIconLampFill: BIconLampFill,
    BIconLaptop: BIconLaptop,
    BIconLaptopFill: BIconLaptopFill,
    BIconLayerBackward: BIconLayerBackward,
    BIconLayerForward: BIconLayerForward,
    BIconLayers: BIconLayers,
    BIconLayersFill: BIconLayersFill,
    BIconLayersHalf: BIconLayersHalf,
    BIconLayoutSidebar: BIconLayoutSidebar,
    BIconLayoutSidebarInset: BIconLayoutSidebarInset,
    BIconLayoutSidebarInsetReverse: BIconLayoutSidebarInsetReverse,
    BIconLayoutSidebarReverse: BIconLayoutSidebarReverse,
    BIconLayoutSplit: BIconLayoutSplit,
    BIconLayoutTextSidebar: BIconLayoutTextSidebar,
    BIconLayoutTextSidebarReverse: BIconLayoutTextSidebarReverse,
    BIconLayoutTextWindow: BIconLayoutTextWindow,
    BIconLayoutTextWindowReverse: BIconLayoutTextWindowReverse,
    BIconLayoutThreeColumns: BIconLayoutThreeColumns,
    BIconLayoutWtf: BIconLayoutWtf,
    BIconLifePreserver: BIconLifePreserver,
    BIconLightbulb: BIconLightbulb,
    BIconLightbulbFill: BIconLightbulbFill,
    BIconLightbulbOff: BIconLightbulbOff,
    BIconLightbulbOffFill: BIconLightbulbOffFill,
    BIconLightning: BIconLightning,
    BIconLightningCharge: BIconLightningCharge,
    BIconLightningChargeFill: BIconLightningChargeFill,
    BIconLightningFill: BIconLightningFill,
    BIconLink: BIconLink,
    BIconLink45deg: BIconLink45deg,
    BIconLinkedin: BIconLinkedin,
    BIconList: BIconList,
    BIconListCheck: BIconListCheck,
    BIconListNested: BIconListNested,
    BIconListOl: BIconListOl,
    BIconListStars: BIconListStars,
    BIconListTask: BIconListTask,
    BIconListUl: BIconListUl,
    BIconLock: BIconLock,
    BIconLockFill: BIconLockFill,
    BIconMailbox: BIconMailbox,
    BIconMailbox2: BIconMailbox2,
    BIconMap: BIconMap,
    BIconMapFill: BIconMapFill,
    BIconMarkdown: BIconMarkdown,
    BIconMarkdownFill: BIconMarkdownFill,
    BIconMask: BIconMask,
    BIconMastodon: BIconMastodon,
    BIconMegaphone: BIconMegaphone,
    BIconMegaphoneFill: BIconMegaphoneFill,
    BIconMenuApp: BIconMenuApp,
    BIconMenuAppFill: BIconMenuAppFill,
    BIconMenuButton: BIconMenuButton,
    BIconMenuButtonFill: BIconMenuButtonFill,
    BIconMenuButtonWide: BIconMenuButtonWide,
    BIconMenuButtonWideFill: BIconMenuButtonWideFill,
    BIconMenuDown: BIconMenuDown,
    BIconMenuUp: BIconMenuUp,
    BIconMessenger: BIconMessenger,
    BIconMic: BIconMic,
    BIconMicFill: BIconMicFill,
    BIconMicMute: BIconMicMute,
    BIconMicMuteFill: BIconMicMuteFill,
    BIconMinecart: BIconMinecart,
    BIconMinecartLoaded: BIconMinecartLoaded,
    BIconMoisture: BIconMoisture,
    BIconMoon: BIconMoon,
    BIconMoonFill: BIconMoonFill,
    BIconMoonStars: BIconMoonStars,
    BIconMoonStarsFill: BIconMoonStarsFill,
    BIconMouse: BIconMouse,
    BIconMouse2: BIconMouse2,
    BIconMouse2Fill: BIconMouse2Fill,
    BIconMouse3: BIconMouse3,
    BIconMouse3Fill: BIconMouse3Fill,
    BIconMouseFill: BIconMouseFill,
    BIconMusicNote: BIconMusicNote,
    BIconMusicNoteBeamed: BIconMusicNoteBeamed,
    BIconMusicNoteList: BIconMusicNoteList,
    BIconMusicPlayer: BIconMusicPlayer,
    BIconMusicPlayerFill: BIconMusicPlayerFill,
    BIconNewspaper: BIconNewspaper,
    BIconNodeMinus: BIconNodeMinus,
    BIconNodeMinusFill: BIconNodeMinusFill,
    BIconNodePlus: BIconNodePlus,
    BIconNodePlusFill: BIconNodePlusFill,
    BIconNut: BIconNut,
    BIconNutFill: BIconNutFill,
    BIconOctagon: BIconOctagon,
    BIconOctagonFill: BIconOctagonFill,
    BIconOctagonHalf: BIconOctagonHalf,
    BIconOption: BIconOption,
    BIconOutlet: BIconOutlet,
    BIconPaintBucket: BIconPaintBucket,
    BIconPalette: BIconPalette,
    BIconPalette2: BIconPalette2,
    BIconPaletteFill: BIconPaletteFill,
    BIconPaperclip: BIconPaperclip,
    BIconParagraph: BIconParagraph,
    BIconPatchCheck: BIconPatchCheck,
    BIconPatchCheckFill: BIconPatchCheckFill,
    BIconPatchExclamation: BIconPatchExclamation,
    BIconPatchExclamationFill: BIconPatchExclamationFill,
    BIconPatchMinus: BIconPatchMinus,
    BIconPatchMinusFill: BIconPatchMinusFill,
    BIconPatchPlus: BIconPatchPlus,
    BIconPatchPlusFill: BIconPatchPlusFill,
    BIconPatchQuestion: BIconPatchQuestion,
    BIconPatchQuestionFill: BIconPatchQuestionFill,
    BIconPause: BIconPause,
    BIconPauseBtn: BIconPauseBtn,
    BIconPauseBtnFill: BIconPauseBtnFill,
    BIconPauseCircle: BIconPauseCircle,
    BIconPauseCircleFill: BIconPauseCircleFill,
    BIconPauseFill: BIconPauseFill,
    BIconPeace: BIconPeace,
    BIconPeaceFill: BIconPeaceFill,
    BIconPen: BIconPen,
    BIconPenFill: BIconPenFill,
    BIconPencil: BIconPencil,
    BIconPencilFill: BIconPencilFill,
    BIconPencilSquare: BIconPencilSquare,
    BIconPentagon: BIconPentagon,
    BIconPentagonFill: BIconPentagonFill,
    BIconPentagonHalf: BIconPentagonHalf,
    BIconPeople: BIconPeople,
    BIconPeopleFill: BIconPeopleFill,
    BIconPercent: BIconPercent,
    BIconPerson: BIconPerson,
    BIconPersonBadge: BIconPersonBadge,
    BIconPersonBadgeFill: BIconPersonBadgeFill,
    BIconPersonBoundingBox: BIconPersonBoundingBox,
    BIconPersonCheck: BIconPersonCheck,
    BIconPersonCheckFill: BIconPersonCheckFill,
    BIconPersonCircle: BIconPersonCircle,
    BIconPersonDash: BIconPersonDash,
    BIconPersonDashFill: BIconPersonDashFill,
    BIconPersonFill: BIconPersonFill,
    BIconPersonLinesFill: BIconPersonLinesFill,
    BIconPersonPlus: BIconPersonPlus,
    BIconPersonPlusFill: BIconPersonPlusFill,
    BIconPersonSquare: BIconPersonSquare,
    BIconPersonX: BIconPersonX,
    BIconPersonXFill: BIconPersonXFill,
    BIconPhone: BIconPhone,
    BIconPhoneFill: BIconPhoneFill,
    BIconPhoneLandscape: BIconPhoneLandscape,
    BIconPhoneLandscapeFill: BIconPhoneLandscapeFill,
    BIconPhoneVibrate: BIconPhoneVibrate,
    BIconPhoneVibrateFill: BIconPhoneVibrateFill,
    BIconPieChart: BIconPieChart,
    BIconPieChartFill: BIconPieChartFill,
    BIconPiggyBank: BIconPiggyBank,
    BIconPiggyBankFill: BIconPiggyBankFill,
    BIconPin: BIconPin,
    BIconPinAngle: BIconPinAngle,
    BIconPinAngleFill: BIconPinAngleFill,
    BIconPinFill: BIconPinFill,
    BIconPinMap: BIconPinMap,
    BIconPinMapFill: BIconPinMapFill,
    BIconPip: BIconPip,
    BIconPipFill: BIconPipFill,
    BIconPlay: BIconPlay,
    BIconPlayBtn: BIconPlayBtn,
    BIconPlayBtnFill: BIconPlayBtnFill,
    BIconPlayCircle: BIconPlayCircle,
    BIconPlayCircleFill: BIconPlayCircleFill,
    BIconPlayFill: BIconPlayFill,
    BIconPlug: BIconPlug,
    BIconPlugFill: BIconPlugFill,
    BIconPlus: BIconPlus,
    BIconPlusCircle: BIconPlusCircle,
    BIconPlusCircleDotted: BIconPlusCircleDotted,
    BIconPlusCircleFill: BIconPlusCircleFill,
    BIconPlusLg: BIconPlusLg,
    BIconPlusSquare: BIconPlusSquare,
    BIconPlusSquareDotted: BIconPlusSquareDotted,
    BIconPlusSquareFill: BIconPlusSquareFill,
    BIconPower: BIconPower,
    BIconPrinter: BIconPrinter,
    BIconPrinterFill: BIconPrinterFill,
    BIconPuzzle: BIconPuzzle,
    BIconPuzzleFill: BIconPuzzleFill,
    BIconQuestion: BIconQuestion,
    BIconQuestionCircle: BIconQuestionCircle,
    BIconQuestionCircleFill: BIconQuestionCircleFill,
    BIconQuestionDiamond: BIconQuestionDiamond,
    BIconQuestionDiamondFill: BIconQuestionDiamondFill,
    BIconQuestionLg: BIconQuestionLg,
    BIconQuestionOctagon: BIconQuestionOctagon,
    BIconQuestionOctagonFill: BIconQuestionOctagonFill,
    BIconQuestionSquare: BIconQuestionSquare,
    BIconQuestionSquareFill: BIconQuestionSquareFill,
    BIconRainbow: BIconRainbow,
    BIconReceipt: BIconReceipt,
    BIconReceiptCutoff: BIconReceiptCutoff,
    BIconReception0: BIconReception0,
    BIconReception1: BIconReception1,
    BIconReception2: BIconReception2,
    BIconReception3: BIconReception3,
    BIconReception4: BIconReception4,
    BIconRecord: BIconRecord,
    BIconRecord2: BIconRecord2,
    BIconRecord2Fill: BIconRecord2Fill,
    BIconRecordBtn: BIconRecordBtn,
    BIconRecordBtnFill: BIconRecordBtnFill,
    BIconRecordCircle: BIconRecordCircle,
    BIconRecordCircleFill: BIconRecordCircleFill,
    BIconRecordFill: BIconRecordFill,
    BIconRecycle: BIconRecycle,
    BIconReddit: BIconReddit,
    BIconReply: BIconReply,
    BIconReplyAll: BIconReplyAll,
    BIconReplyAllFill: BIconReplyAllFill,
    BIconReplyFill: BIconReplyFill,
    BIconRss: BIconRss,
    BIconRssFill: BIconRssFill,
    BIconRulers: BIconRulers,
    BIconSafe: BIconSafe,
    BIconSafe2: BIconSafe2,
    BIconSafe2Fill: BIconSafe2Fill,
    BIconSafeFill: BIconSafeFill,
    BIconSave: BIconSave,
    BIconSave2: BIconSave2,
    BIconSave2Fill: BIconSave2Fill,
    BIconSaveFill: BIconSaveFill,
    BIconScissors: BIconScissors,
    BIconScrewdriver: BIconScrewdriver,
    BIconSdCard: BIconSdCard,
    BIconSdCardFill: BIconSdCardFill,
    BIconSearch: BIconSearch,
    BIconSegmentedNav: BIconSegmentedNav,
    BIconServer: BIconServer,
    BIconShare: BIconShare,
    BIconShareFill: BIconShareFill,
    BIconShield: BIconShield,
    BIconShieldCheck: BIconShieldCheck,
    BIconShieldExclamation: BIconShieldExclamation,
    BIconShieldFill: BIconShieldFill,
    BIconShieldFillCheck: BIconShieldFillCheck,
    BIconShieldFillExclamation: BIconShieldFillExclamation,
    BIconShieldFillMinus: BIconShieldFillMinus,
    BIconShieldFillPlus: BIconShieldFillPlus,
    BIconShieldFillX: BIconShieldFillX,
    BIconShieldLock: BIconShieldLock,
    BIconShieldLockFill: BIconShieldLockFill,
    BIconShieldMinus: BIconShieldMinus,
    BIconShieldPlus: BIconShieldPlus,
    BIconShieldShaded: BIconShieldShaded,
    BIconShieldSlash: BIconShieldSlash,
    BIconShieldSlashFill: BIconShieldSlashFill,
    BIconShieldX: BIconShieldX,
    BIconShift: BIconShift,
    BIconShiftFill: BIconShiftFill,
    BIconShop: BIconShop,
    BIconShopWindow: BIconShopWindow,
    BIconShuffle: BIconShuffle,
    BIconSignpost: BIconSignpost,
    BIconSignpost2: BIconSignpost2,
    BIconSignpost2Fill: BIconSignpost2Fill,
    BIconSignpostFill: BIconSignpostFill,
    BIconSignpostSplit: BIconSignpostSplit,
    BIconSignpostSplitFill: BIconSignpostSplitFill,
    BIconSim: BIconSim,
    BIconSimFill: BIconSimFill,
    BIconSkipBackward: BIconSkipBackward,
    BIconSkipBackwardBtn: BIconSkipBackwardBtn,
    BIconSkipBackwardBtnFill: BIconSkipBackwardBtnFill,
    BIconSkipBackwardCircle: BIconSkipBackwardCircle,
    BIconSkipBackwardCircleFill: BIconSkipBackwardCircleFill,
    BIconSkipBackwardFill: BIconSkipBackwardFill,
    BIconSkipEnd: BIconSkipEnd,
    BIconSkipEndBtn: BIconSkipEndBtn,
    BIconSkipEndBtnFill: BIconSkipEndBtnFill,
    BIconSkipEndCircle: BIconSkipEndCircle,
    BIconSkipEndCircleFill: BIconSkipEndCircleFill,
    BIconSkipEndFill: BIconSkipEndFill,
    BIconSkipForward: BIconSkipForward,
    BIconSkipForwardBtn: BIconSkipForwardBtn,
    BIconSkipForwardBtnFill: BIconSkipForwardBtnFill,
    BIconSkipForwardCircle: BIconSkipForwardCircle,
    BIconSkipForwardCircleFill: BIconSkipForwardCircleFill,
    BIconSkipForwardFill: BIconSkipForwardFill,
    BIconSkipStart: BIconSkipStart,
    BIconSkipStartBtn: BIconSkipStartBtn,
    BIconSkipStartBtnFill: BIconSkipStartBtnFill,
    BIconSkipStartCircle: BIconSkipStartCircle,
    BIconSkipStartCircleFill: BIconSkipStartCircleFill,
    BIconSkipStartFill: BIconSkipStartFill,
    BIconSkype: BIconSkype,
    BIconSlack: BIconSlack,
    BIconSlash: BIconSlash,
    BIconSlashCircle: BIconSlashCircle,
    BIconSlashCircleFill: BIconSlashCircleFill,
    BIconSlashLg: BIconSlashLg,
    BIconSlashSquare: BIconSlashSquare,
    BIconSlashSquareFill: BIconSlashSquareFill,
    BIconSliders: BIconSliders,
    BIconSmartwatch: BIconSmartwatch,
    BIconSnow: BIconSnow,
    BIconSnow2: BIconSnow2,
    BIconSnow3: BIconSnow3,
    BIconSortAlphaDown: BIconSortAlphaDown,
    BIconSortAlphaDownAlt: BIconSortAlphaDownAlt,
    BIconSortAlphaUp: BIconSortAlphaUp,
    BIconSortAlphaUpAlt: BIconSortAlphaUpAlt,
    BIconSortDown: BIconSortDown,
    BIconSortDownAlt: BIconSortDownAlt,
    BIconSortNumericDown: BIconSortNumericDown,
    BIconSortNumericDownAlt: BIconSortNumericDownAlt,
    BIconSortNumericUp: BIconSortNumericUp,
    BIconSortNumericUpAlt: BIconSortNumericUpAlt,
    BIconSortUp: BIconSortUp,
    BIconSortUpAlt: BIconSortUpAlt,
    BIconSoundwave: BIconSoundwave,
    BIconSpeaker: BIconSpeaker,
    BIconSpeakerFill: BIconSpeakerFill,
    BIconSpeedometer: BIconSpeedometer,
    BIconSpeedometer2: BIconSpeedometer2,
    BIconSpellcheck: BIconSpellcheck,
    BIconSquare: BIconSquare,
    BIconSquareFill: BIconSquareFill,
    BIconSquareHalf: BIconSquareHalf,
    BIconStack: BIconStack,
    BIconStar: BIconStar,
    BIconStarFill: BIconStarFill,
    BIconStarHalf: BIconStarHalf,
    BIconStars: BIconStars,
    BIconStickies: BIconStickies,
    BIconStickiesFill: BIconStickiesFill,
    BIconSticky: BIconSticky,
    BIconStickyFill: BIconStickyFill,
    BIconStop: BIconStop,
    BIconStopBtn: BIconStopBtn,
    BIconStopBtnFill: BIconStopBtnFill,
    BIconStopCircle: BIconStopCircle,
    BIconStopCircleFill: BIconStopCircleFill,
    BIconStopFill: BIconStopFill,
    BIconStoplights: BIconStoplights,
    BIconStoplightsFill: BIconStoplightsFill,
    BIconStopwatch: BIconStopwatch,
    BIconStopwatchFill: BIconStopwatchFill,
    BIconSubtract: BIconSubtract,
    BIconSuitClub: BIconSuitClub,
    BIconSuitClubFill: BIconSuitClubFill,
    BIconSuitDiamond: BIconSuitDiamond,
    BIconSuitDiamondFill: BIconSuitDiamondFill,
    BIconSuitHeart: BIconSuitHeart,
    BIconSuitHeartFill: BIconSuitHeartFill,
    BIconSuitSpade: BIconSuitSpade,
    BIconSuitSpadeFill: BIconSuitSpadeFill,
    BIconSun: BIconSun,
    BIconSunFill: BIconSunFill,
    BIconSunglasses: BIconSunglasses,
    BIconSunrise: BIconSunrise,
    BIconSunriseFill: BIconSunriseFill,
    BIconSunset: BIconSunset,
    BIconSunsetFill: BIconSunsetFill,
    BIconSymmetryHorizontal: BIconSymmetryHorizontal,
    BIconSymmetryVertical: BIconSymmetryVertical,
    BIconTable: BIconTable,
    BIconTablet: BIconTablet,
    BIconTabletFill: BIconTabletFill,
    BIconTabletLandscape: BIconTabletLandscape,
    BIconTabletLandscapeFill: BIconTabletLandscapeFill,
    BIconTag: BIconTag,
    BIconTagFill: BIconTagFill,
    BIconTags: BIconTags,
    BIconTagsFill: BIconTagsFill,
    BIconTelegram: BIconTelegram,
    BIconTelephone: BIconTelephone,
    BIconTelephoneFill: BIconTelephoneFill,
    BIconTelephoneForward: BIconTelephoneForward,
    BIconTelephoneForwardFill: BIconTelephoneForwardFill,
    BIconTelephoneInbound: BIconTelephoneInbound,
    BIconTelephoneInboundFill: BIconTelephoneInboundFill,
    BIconTelephoneMinus: BIconTelephoneMinus,
    BIconTelephoneMinusFill: BIconTelephoneMinusFill,
    BIconTelephoneOutbound: BIconTelephoneOutbound,
    BIconTelephoneOutboundFill: BIconTelephoneOutboundFill,
    BIconTelephonePlus: BIconTelephonePlus,
    BIconTelephonePlusFill: BIconTelephonePlusFill,
    BIconTelephoneX: BIconTelephoneX,
    BIconTelephoneXFill: BIconTelephoneXFill,
    BIconTerminal: BIconTerminal,
    BIconTerminalFill: BIconTerminalFill,
    BIconTextCenter: BIconTextCenter,
    BIconTextIndentLeft: BIconTextIndentLeft,
    BIconTextIndentRight: BIconTextIndentRight,
    BIconTextLeft: BIconTextLeft,
    BIconTextParagraph: BIconTextParagraph,
    BIconTextRight: BIconTextRight,
    BIconTextarea: BIconTextarea,
    BIconTextareaResize: BIconTextareaResize,
    BIconTextareaT: BIconTextareaT,
    BIconThermometer: BIconThermometer,
    BIconThermometerHalf: BIconThermometerHalf,
    BIconThermometerHigh: BIconThermometerHigh,
    BIconThermometerLow: BIconThermometerLow,
    BIconThermometerSnow: BIconThermometerSnow,
    BIconThermometerSun: BIconThermometerSun,
    BIconThreeDots: BIconThreeDots,
    BIconThreeDotsVertical: BIconThreeDotsVertical,
    BIconToggle2Off: BIconToggle2Off,
    BIconToggle2On: BIconToggle2On,
    BIconToggleOff: BIconToggleOff,
    BIconToggleOn: BIconToggleOn,
    BIconToggles: BIconToggles,
    BIconToggles2: BIconToggles2,
    BIconTools: BIconTools,
    BIconTornado: BIconTornado,
    BIconTranslate: BIconTranslate,
    BIconTrash: BIconTrash,
    BIconTrash2: BIconTrash2,
    BIconTrash2Fill: BIconTrash2Fill,
    BIconTrashFill: BIconTrashFill,
    BIconTree: BIconTree,
    BIconTreeFill: BIconTreeFill,
    BIconTriangle: BIconTriangle,
    BIconTriangleFill: BIconTriangleFill,
    BIconTriangleHalf: BIconTriangleHalf,
    BIconTrophy: BIconTrophy,
    BIconTrophyFill: BIconTrophyFill,
    BIconTropicalStorm: BIconTropicalStorm,
    BIconTruck: BIconTruck,
    BIconTruckFlatbed: BIconTruckFlatbed,
    BIconTsunami: BIconTsunami,
    BIconTv: BIconTv,
    BIconTvFill: BIconTvFill,
    BIconTwitch: BIconTwitch,
    BIconTwitter: BIconTwitter,
    BIconType: BIconType,
    BIconTypeBold: BIconTypeBold,
    BIconTypeH1: BIconTypeH1,
    BIconTypeH2: BIconTypeH2,
    BIconTypeH3: BIconTypeH3,
    BIconTypeItalic: BIconTypeItalic,
    BIconTypeStrikethrough: BIconTypeStrikethrough,
    BIconTypeUnderline: BIconTypeUnderline,
    BIconUiChecks: BIconUiChecks,
    BIconUiChecksGrid: BIconUiChecksGrid,
    BIconUiRadios: BIconUiRadios,
    BIconUiRadiosGrid: BIconUiRadiosGrid,
    BIconUmbrella: BIconUmbrella,
    BIconUmbrellaFill: BIconUmbrellaFill,
    BIconUnion: BIconUnion,
    BIconUnlock: BIconUnlock,
    BIconUnlockFill: BIconUnlockFill,
    BIconUpc: BIconUpc,
    BIconUpcScan: BIconUpcScan,
    BIconUpload: BIconUpload,
    BIconVectorPen: BIconVectorPen,
    BIconViewList: BIconViewList,
    BIconViewStacked: BIconViewStacked,
    BIconVinyl: BIconVinyl,
    BIconVinylFill: BIconVinylFill,
    BIconVoicemail: BIconVoicemail,
    BIconVolumeDown: BIconVolumeDown,
    BIconVolumeDownFill: BIconVolumeDownFill,
    BIconVolumeMute: BIconVolumeMute,
    BIconVolumeMuteFill: BIconVolumeMuteFill,
    BIconVolumeOff: BIconVolumeOff,
    BIconVolumeOffFill: BIconVolumeOffFill,
    BIconVolumeUp: BIconVolumeUp,
    BIconVolumeUpFill: BIconVolumeUpFill,
    BIconVr: BIconVr,
    BIconWallet: BIconWallet,
    BIconWallet2: BIconWallet2,
    BIconWalletFill: BIconWalletFill,
    BIconWatch: BIconWatch,
    BIconWater: BIconWater,
    BIconWhatsapp: BIconWhatsapp,
    BIconWifi: BIconWifi,
    BIconWifi1: BIconWifi1,
    BIconWifi2: BIconWifi2,
    BIconWifiOff: BIconWifiOff,
    BIconWind: BIconWind,
    BIconWindow: BIconWindow,
    BIconWindowDock: BIconWindowDock,
    BIconWindowSidebar: BIconWindowSidebar,
    BIconWrench: BIconWrench,
    BIconX: BIconX,
    BIconXCircle: BIconXCircle,
    BIconXCircleFill: BIconXCircleFill,
    BIconXDiamond: BIconXDiamond,
    BIconXDiamondFill: BIconXDiamondFill,
    BIconXLg: BIconXLg,
    BIconXOctagon: BIconXOctagon,
    BIconXOctagonFill: BIconXOctagonFill,
    BIconXSquare: BIconXSquare,
    BIconXSquareFill: BIconXSquareFill,
    BIconYoutube: BIconYoutube,
    BIconZoomIn: BIconZoomIn,
    BIconZoomOut: BIconZoomOut
  }
}); // Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds

export var BootstrapVueIcons = /*#__PURE__*/pluginFactoryNoConfig({
  plugins: {
    IconsPlugin: IconsPlugin
  }
}, {
  NAME: 'BootstrapVueIcons'
}); // --- END AUTO-GENERATED FILE ---


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/icons/plugin.js
// module id = 477
// module chunks = 1